import type { Locale } from "./types";

// Flat key→string dictionary. Use {0}, {1} for positional params.
type Dict = Record<string, string>;

const fr: Dict = {
  // Header
  "header.brand": "Glow Up Coach",
  "header.nav.method": "Méthodologie",
  "header.nav.premium": "Premium",
  "header.nav.billing": "Mon abonnement",
  "index.demo.expand": "Agrandir",
  "index.demo.close": "Fermer",
  "index.demo.slider": "Curseur avant/après",
  "index.premium.label": "Votre abonnement Premium",
  "index.premium.title": "Vous êtes Premium ✨",
  "index.premium.desc": "Merci de votre soutien. Continuez à analyser votre évolution et retrouvez tout votre historique.",
  "index.premium.cta": "Voir mon historique",
  "header.nav.privacy": "Confidentialité",
  "header.nav.my_analysis": "Mon analyse",
  "header.nav.account": "Compte",
  "header.nav.sign_out": "Déconnexion",
  "header.cta.sign_in": "Se connecter",
  "header.nav.progress": "Progression",
  "header.nav.history": "Historique",
  "history.head.title": "Historique des conseils — Glow Up Coach",
  "history.kicker": "Votre journal",
  "history.title": "Historique de vos conseils",
  "history.subtitle": "Retrouvez l'intégralité des conseils générés à chaque analyse, ainsi que vos selfies si vous avez activé leur conservation.",
  "history.loading": "Chargement de votre historique…",
  "history.empty.title": "Aucune analyse pour le moment",
  "history.empty.desc": "Lancez une première analyse pour démarrer votre journal.",
  "history.empty.cta": "Faire une analyse",
  "history.photo_alt": "Selfie de l'analyse",
  "history.no_photo": "Selfie non conservé (consentement non donné)",
  "history.back": "← Retour à mon analyse",

  // Index — head
  "index.head.title": "Glow Up Coach — Coach photo IA hebdomadaire",
  "index.head.desc": "Un selfie par semaine. Notre IA analyse votre peau, posture et vitalité. Au moins 3 conseils concrets. Hébergé en UE.",
  "index.head.og_title": "Glow Up Coach — Coach photo IA",
  "index.head.og_desc": "Analyse hebdomadaire de votre évolution faciale par IA. Privé. Européen.",

  // Index — hero
  "index.hero.badge": "IA Vision de Précision",
  "index.hero.title.start": "Votre visage est votre meilleur",
  "index.hero.title.accent": "biomarqueur.",
  "index.hero.subtitle": "Une photo par semaine. Une analyse IA profonde de votre peau, posture et vitalité. Recevez au moins 3 actions concrètes pour optimiser votre santé.",
  "index.hero.cta.analyze": "Analyser mon selfie",
  // Slogans (filtres / monde réel)
  "slogan.highlight.kicker": "Le manifeste",
  "slogan.highlight.title": "Arrêtez de filtrer, commencez à glow-up.",
  "slogan.highlight.body": "Votre coach IA analyse vos photos chaque semaine et vous guide vers votre meilleure version — celle qui existe vraiment, hors écran.",
  "slogan.s1": "Oubliez les filtres Instagram. Chaque semaine, notre IA analyse vos selfies et vous montre comment briller pour de vrai.",
  "slogan.s2": "Les filtres masquent. Notre coach IA révèle. Un selfie par semaine, des progrès visibles à l'œil nu.",
  "slogan.s3": "Dans le monde réel, vous n'avez pas de filtre. Heureusement, vous avez un coach IA qui vous fait progresser semaine après semaine.",
  "slogan.s4": "La beauté ne s'applique pas en un clic — elle se construit. Coach photo IA hebdomadaire, sans filtre, sans triche.",
  "slogan.s5": "Dans le monde réel, pas de filtre pour vous sauver. Notre IA, si : analyse hebdo + conseils personnalisés.",
  "slogan.s6": "Le seul filtre dont vous aurez besoin : votre propre progression.",
  "index.hero.cta.demo": "Voir un exemple",
  "index.hero.privacy.eu_line1": "Données cryptées & hébergées",
  "index.hero.privacy.eu_line2": "exclusivement en Union Européenne",

  // Index — demo
  "index.demo.week_title": "Analyse Semaine 04",
  "index.demo.week_goal": "Objectif : Vitalité & Anti-Âge",
  "index.demo.before": "AVANT • S01",
  "index.demo.after": "APRÈS • S04",
  "index.demo.metric.skin": "Luminosité Peau",
  "index.demo.metric.posture": "Posture Cervicale",
  "index.demo.metric.eye": "Repos Oculaire",
  "index.demo.metric.stable": "Stable",
  "index.demo.plan.title": "Le Plan S05",
  "index.demo.plan.t1.title": "Hydratation Ciblée",
  "index.demo.plan.t1.text": "Augmentez votre apport en eau de 500ml le matin pour réduire les poches sous les yeux détectées.",
  "index.demo.plan.t2.title": "Correction Ergonomique",
  "index.demo.plan.t2.text": "Relevez votre écran de 5cm. L'IA détecte une tension persistante du trapèze gauche.",
  "index.demo.plan.t3.title": "Protocole Sommeil",
  "index.demo.plan.t3.text": "Dernier repas 3h avant le coucher. Vos tissus faciaux montrent des signes de digestion nocturne active.",
  "index.demo.pricing.label": "Premium",
  "index.demo.pricing.title": "Analyse hebdomadaire illimitée",
  "index.demo.pricing.desc": "Plan détaillé, comparaisons multi-semaines, rappels intelligents et historique chiffré.",
  "index.demo.pricing.cta": "Passer à Premium • 4,99€/mois",
  "index.demo.pricing.free": "Gratuit : 1 analyse / mois",

  // Index — methodology
  "index.method.b1.title": "Vision Objective",
  "index.method.b1.text": "L'œil humain s'habitue au changement. Notre IA mesure l'évolution millimétrique que vous ne pouvez pas voir.",
  "index.method.b2.title": "Bio-Individualité",
  "index.method.b2.text": "Pas de conseils génériques. Chaque recommandation est basée sur la réaction physiologique de VOTRE corps.",
  "index.method.b3.title": "Souveraineté Totale",
  "index.method.b3.text": "Vos données ne quittent jamais l'Europe. Pas de cloud public. Une confidentialité de niveau médical.",

  // Index — footer
  "index.footer.copy": "© 2026 Glow Up Coach · Développé en Europe",
  "index.footer.privacy": "Privacy",
  "index.footer.premium": "Premium",

  // Login
  "login.head.title": "Connexion — Glow Up Coach",
  "login.title.signin": "Se connecter",
  "login.title.signup": "Créer un compte",
  "login.subtitle.signin": "Reprenez votre suivi hebdomadaire.",
  "login.subtitle.signup": "Démarrez votre première analyse en 30 secondes.",
  "login.oauth.google": "Continuer avec Google",
  "login.oauth.apple": "Continuer avec Apple",
  "login.divider.or": "ou",
  "login.input.email": "Email",
  "login.input.password": "Mot de passe (8 caractères min.)",
  "login.btn.signin": "Se connecter",
  "login.btn.signup": "Créer mon compte",
  "login.toggle.to_signup": "Pas encore de compte ? S'inscrire",
  "login.toggle.to_signin": "Déjà inscrit ? Se connecter",
  "login.back_home": "← Retour à l'accueil",
  "login.toast.check_email": "Vérifiez votre email pour confirmer votre compte.",
  "login.toast.generic_error": "Erreur",
  "login.toast.oauth_error": "Erreur {0}",
  "login.forgot_password": "Mot de passe oublié ?",
  "forgot.head.title": "Mot de passe oublié — Glow Up Coach",
  "forgot.title": "Mot de passe oublié",
  "forgot.subtitle": "Entrez votre email, nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  "forgot.input.email": "Email",
  "forgot.btn.send": "Envoyer le lien",
  "forgot.toast.sent": "Email envoyé. Vérifiez votre boîte de réception.",
  "forgot.back_login": "← Retour à la connexion",
  "reset.head.title": "Nouveau mot de passe — Glow Up Coach",
  "reset.title": "Nouveau mot de passe",
  "reset.subtitle": "Choisissez un nouveau mot de passe pour votre compte.",
  "reset.input.password": "Nouveau mot de passe (8 caractères min.)",
  "reset.btn.update": "Mettre à jour",
  "reset.toast.updated": "Mot de passe mis à jour.",
  "reset.invalid_link": "Lien invalide ou expiré. Demandez un nouveau lien.",

  // Checkout
  "checkout.head.title": "Passer Premium — Glow Up Coach",
  "checkout.title": "Glow Up Premium",
  "checkout.subtitle": "Analyses illimitées, plan détaillé, comparaisons avant/après. Annulez à tout moment.",
  "checkout.plan.monthly.label": "Mensuel",
  "checkout.plan.monthly.price_amount": "4,99 €",
  "checkout.plan.monthly.price_period": "/mois",
  "checkout.plan.yearly.label": "Annuel · 2 mois offerts",
  "checkout.plan.yearly.price_amount": "49 €",
  "checkout.plan.yearly.price_period": "/an",
  "checkout.plan.tax_badge": "TTC",
  "checkout.plan.tax_note": "Prix toutes taxes comprises (TVA incluse).",

  // Checkout return
  "checkout_return.head.title": "Bienvenue Premium — Glow Up Coach",
  "checkout_return.title.activated": "Bienvenue dans Premium.",
  "checkout_return.title.waiting": "Activation en cours…",
  "checkout_return.title.received": "Paiement reçu.",
  "checkout_return.desc.no_session": "Session introuvable.",
  "checkout_return.desc.activated": "Votre abonnement est actif. Analyses illimitées débloquées.",
  "checkout_return.desc.waiting": "Nous confirmons votre abonnement auprès de Stripe (quelques secondes)…",
  "checkout_return.desc.received": "Votre paiement est reçu. Si l'accès Premium n'apparaît pas dans quelques minutes, contactez le support.",
  "checkout_return.cta": "Lancer une analyse",

  // Billing
  "billing.head.title": "Mon abonnement — Glow Up Coach",
  "billing.title": "Mon abonnement",
  "billing.subtitle": "Gérez votre plan et consultez votre usage du mois.",
  "billing.current_plan": "Plan actuel",
  "billing.plan.premium": "Premium",
  "billing.plan.free": "Gratuit",
  "billing.badge.active": "ACTIF",
  "billing.badge.free": "FREE",
  "billing.this_month": "Ce mois",
  "billing.usage.premium": "analyses réalisées",
  "billing.usage.free": "/ {0} analyse gratuite",
  "billing.cta.manage": "Gérer mon abonnement",
  "billing.cta.monthly": "Mensuel · 4,99 €/mois",
  "billing.cta.yearly": "Annuel · 49 €/an",
  "billing.back": "← Retour à l'analyse",
  "billing.toast.error": "Erreur",
  "billing.cta.monthly_embedded": "Mensuel intégré",
  "billing.cta.yearly_embedded": "Annuel intégré",
  "billing.diag.kicker": "Diagnostic",
  "billing.diag.title": "État Stripe Live",
  "billing.diag.check_cta": "Vérifier l'état Live",
  "billing.diag.checking": "Vérification…",
  "billing.diag.ready": "Prêt",
  "billing.diag.incomplete": "Incomplet",
  "billing.diag.checked_at": "Vérifié à {0}",
  "billing.diag.empty": "Cliquez sur « Vérifier l'état Live » pour interroger l'API Stripe.",
  "billing.diag.error": "Erreur lors de la vérification",
  "checkout.return.head.title": "Paiement confirmé — Glow Up Coach",
  "checkout.return.success.title": "Premium activé",
  "checkout.return.success.desc": "Merci ! Redirection vers votre espace abonnement…",
  "checkout.return.success.cta": "Voir mon abonnement",
  "checkout.return.pending.title": "Confirmation en cours",
  "checkout.return.pending.desc": "Nous finalisons votre abonnement. Cela prend quelques secondes…",

  // Account
  "account.head.title": "Mon compte & confidentialité — Glow Up Coach",
  "account.head.desc": "Gérez vos données : exportez, ou demandez la suppression définitive de vos selfies, analyses et historique (RGPD, hébergement UE).",
  "account.label": "Mon compte",
  "account.title": "Confidentialité & données",
  "account.signed_in_as": "Connecté en tant que",
  "account.eu_note": "Hébergement et traitement en",
  "account.eu": "Union européenne",
  "account.stored.title": "Ce que nous stockons",
  "account.stored.selfies": "Selfies",
  "account.stored.selfies_text": "jamais conservés sur nos serveurs — uniquement transmis à l'IA le temps de l'analyse, puis supprimés.",
  "account.stored.history": "Analyses & historique",
  "account.stored.history_text": "résumé IA, score, indicateurs et conseils générés à chaque analyse.",
  "account.stored.consent": "Consentement RGPD",
  "account.stored.consent_text": "vos choix de stockage et d'usage (dans votre navigateur).",
  "account.delete.title": "Supprimer toutes mes données",
  "account.delete.desc": "Suppression définitive et immédiate de l'ensemble de vos analyses, de votre historique et de votre consentement. Action irréversible. Conforme RGPD (droit à l'effacement, art. 17). Données traitées en UE.",
  "account.delete.done": "✓ Suppression effectuée",
  "account.delete.analyses_deleted": "{0} analyse(s) supprimée(s)",
  "account.delete.sub_canceled": "Abonnement {0} annulé",
  "account.delete.refund": "Remboursement prorata : {0} {1}",
  "account.delete.no_refund": "Aucun remboursement (pas de période entamée)",
  "account.delete.no_sub": "Aucun abonnement actif à annuler",
  "account.delete.region": "Région :",
  "account.delete.at": "Le :",
  "account.delete.sign_out": "Se déconnecter",
  "account.delete.request": "Demander la suppression",
  "account.delete.confirm_prompt": "Pour confirmer, tapez",
  "account.delete.confirm_suffix": "ci-dessous.",
  "account.delete.deleting": "Suppression…",
  "account.delete.confirm_btn": "Supprimer définitivement",
  "account.delete.cancel": "Annuler",
  "account.delete.back": "← Retour à mon analyse",
  "account.toast.deleted": "Vos données ont été supprimées.",
  "account.toast.error": "Suppression impossible",

  // App page
  "app.head.title": "Mon analyse IA — Glow Up Coach",
  "app.head.desc": "Importez votre selfie hebdomadaire et recevez 3 conseils personnalisés instantanés.",
  "app.usage.premium": "Premium actif",
  "app.usage.free": "Plan gratuit",
  "app.usage.this_month_premium": "{0} analyses ce mois",
  "app.usage.this_month_free": "{0} / {1} analyse gratuite ce mois",
  "app.usage.upgrade": "Passer Premium · 4,99€",
  "app.step1": "Étape 1 / 2",
  "app.step1.title": "Choisissez votre objectif.",
  "app.step1.desc": "L'IA adapte son analyse et ses conseils à votre intention.",
  "app.goal.skin": "Peau & Éclat",
  "app.goal.skin.desc": "Hydratation, texture, luminosité",
  "app.goal.weight": "Forme physique",
  "app.goal.weight.desc": "Vitalité, perte de poids visible",
  "app.goal.muscle": "Tonus musculaire",
  "app.goal.muscle.desc": "Posture, symétrie, énergie",
  "app.goal.antiaging": "Anti-âge",
  "app.goal.antiaging.desc": "Élasticité, repos, longévité",
  "app.step2": "Étape 2 / 2",
  "app.step2.title": "Importez votre selfie hebdo.",
  "app.step2.desc": "Lumière naturelle, visage centré, expression neutre. Données traitées en UE, jamais stockées sans votre accord.",
  "app.upload.prompt": "Cliquez ou glissez votre photo",
  "app.upload.specs": "JPG / PNG · max 45 Mo",
  "app.upload.alt": "Votre selfie",
  "app.result.loading": "Analyse en cours…",
  "app.result.placeholder": "Votre analyse apparaîtra ici.",
  "app.result.title": "Synthèse IA",
  "app.report.generating": "Génération…",
  "app.report.download": "Télécharger mon rapport PDF Avant/Après",
  "app.report.subline": "Synthèse IA, 3 conseils et comparaison semaine par semaine.",
  "app.back_home": "← Retour à l'accueil",
  "app.toast.image_too_large": "Image trop grande (max 45 Mo)",
  "app.toast.analyze_error": "Erreur d'analyse",
  "app.toast.report_error": "Impossible de générer le rapport",
  "app.toast.compressed": "Image optimisée : {0} → {1}",
  "app.upload.phase.reading": "Lecture du fichier…",
  "app.upload.phase.decoding": "Décodage de l'image…",
  "app.upload.phase.resizing": "Redimensionnement…",
  "app.upload.phase.encoding": "Compression…",
  "app.upload.phase.done": "Préparation terminée",
  "app.upload.phase.sending": "Envoi à l'IA…",

  // GDPR modal
  "gdpr.label": "Confidentialité · RGPD",
  "gdpr.title": "Vos données, vos choix.",
  "gdpr.intro": "Avant votre première analyse, indiquez-nous comment vous souhaitez que vos selfies et résultats soient traités. Vous pouvez modifier ces choix à tout moment depuis votre compte.",
  "gdpr.analyse.title": "Traitement de mon selfie pour générer mon analyse",
  "gdpr.analyse.required": "(requis)",
  "gdpr.analyse.desc": "Votre photo est envoyée à notre IA pour produire vos conseils personnalisés. Hébergement en UE.",
  "gdpr.store.title": "Conserver mes selfies pour le suivi long-terme",
  "gdpr.store.optional": "(optionnel)",
  "gdpr.store.desc": "Nous gardons vos photos chiffrées pour comparer votre progression semaine après semaine. Si décoché, vos photos sont supprimées immédiatement après l'analyse.",
  "gdpr.improve.title": "Utiliser mes données anonymisées pour améliorer l'IA",
  "gdpr.improve.optional": "(optionnel)",
  "gdpr.improve.desc": "Aide-nous à affiner nos modèles. Aucune donnée identifiante n'est conservée.",
  "gdpr.legal": "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Contact : privacy@glowupcoach.ai.",
  "gdpr.cancel": "Annuler",
  "gdpr.accept": "Accepter et continuer",

  // Language switcher
  "lang.label": "Langue",
  "payments.test_banner.text": "Paiements en mode test dans la preview.",
  "payments.test_banner.link": "En savoir plus",
  // Progress page
  "progress.head.title": "Ma progression — Glow Up Coach",
  "progress.kicker": "Avant / Après",
  "progress.title": "Votre glow-up, semaine après semaine",
  "progress.subtitle": "Visualisez l'évolution de vos analyses et retrouvez vos 3 conseils ultra-concrets du moment.",
  "progress.loading": "Chargement de votre progression…",
  "progress.empty.title": "Aucune analyse pour le moment",
  "progress.empty.desc": "Lancez votre première analyse pour démarrer le suivi semaine par semaine.",
  "progress.empty.cta": "Lancer une analyse",
  "progress.stat.weeks": "Semaines suivies",
  "progress.stat.analyses": "Analyses totales",
  "progress.stat.delta": "Évolution du score",
  "progress.timeline.title": "Évolution semaine par semaine",
  "progress.tips.kicker": "À faire cette semaine",
  "progress.tips.title": "Vos 3 conseils ultra-concrets",
  "progress.tips.empty": "Vos conseils apparaîtront ici après votre prochaine analyse.",
  "progress.back_to_app": "← Retour à mon analyse",
  // Quick analyze flow
  "quick.head.title": "Analyse express — Glow Up Coach",
  "quick.kicker": "Analyse express",
  "quick.title": "Téléversez un selfie, voyez l'avant / après",
  "quick.subtitle": "Un objectif, une photo, votre résultat avant/après en quelques secondes.",
  "quick.upload.prompt": "Téléverser un selfie",
  "quick.before": "Avant",
  "quick.after": "Après",
  "quick.no_previous": "Première analyse — pas encore d'avant",
  "quick.metrics": "Vos indicateurs",
  "quick.tips.kicker": "À faire dès maintenant",
  "quick.tips.title": "3 conseils ultra-concrets",
  "quick.retry": "Refaire une analyse",
  "quick.see_progress": "Voir ma progression",
  "index.hero.cta.quick": "Analyser mon selfie maintenant",
  "index.demo.slider.hint": "Glissez pour comparer",
  "index.demo.timeline.kicker": "Évolution sur 4 semaines",
  "index.demo.timeline.prev": "Précédent",
  "index.demo.timeline.next": "Suivant",
  "index.demo.week.label": "Semaine {0}",
  "index.demo.week.play": "Lecture auto",
  "index.demo.week.pause": "Pause",
  "index.demo.subject.kicker": "Choisissez un profil",
  "index.demo.subject.matureMan1": "Homme mature 1",
  "index.demo.subject.matureMan2": "Homme mature 2",
  "index.demo.subject.midageMan1": "Homme âge moyen 1",
  "index.demo.subject.midageMan2": "Homme âge moyen 2",
  "index.demo.subject.youngMan1": "Jeune homme 1",
  "index.demo.subject.youngMan2": "Jeune homme 2",
  "index.demo.subject.matureWoman1": "Femme mature 1",
  "index.demo.subject.matureWoman2": "Femme mature 2",
  "index.demo.subject.midageWoman1": "Femme âge moyen 1",
  "index.demo.subject.midageWoman2": "Femme âge moyen 2",
  "index.demo.subject.youngWoman1": "Jeune femme 1",
  "index.demo.subject.youngWoman2": "Jeune femme 2",
  "index.demo.regen.cta": "Régénérer la série",
  "index.demo.regen.loading": "Régénération…",
  "index.demo.regen.done": "Paires régénérées",
  "index.demo.regen.error": "Échec de la régénération",
  "index.demo.qa.cta": "Mode QA",
  "index.demo.qa.kicker": "Contrôle qualité",
  "index.demo.qa.loading": "Calcul en cours…",
  "index.demo.qa.hint": "Distance perceptuelle (dHash) entre Avant et chaque Après",
  "index.demo.qa.source.asset": "Asset",
  "index.demo.qa.source.ai": "IA",
  "index.demo.qa.distance": "Distance",
  "index.demo.qa.dimensions": "Dimensions",
  "index.demo.qa.size": "Poids",
  "index.demo.qa.model": "Modèle",
  "index.demo.qa.elapsed": "Durée",
  "index.demo.qa.generatedAt": "Généré à",
  "index.demo.qa.prompt": "Prompt",
  "header.nav.protocols": "Suivi spécialisé",
  "protocols.kicker": "Suivi spécialisé",
  "protocols.title": "Vos protocoles guidés",
  "protocols.subtitle": "Suivez votre récupération ou votre transition avec des protocoles cadrés, étape par étape.",
  "protocols.steps": "étapes",
  "protocols.badge.active": "En cours",
  "protocols.badge.done": "Validé",
  "protocols.cta.start": "Démarrer ce protocole",
  "protocols.cta.mark_done": "Marquer fait",
  "protocols.cta.add_selfie": "+ Ajouter un selfie",
  "protocols.back": "Retour aux protocoles",
  "protocols.not_found": "Protocole introuvable.",
  "protocols.toast.started": "Protocole démarré",
  "protocols.toast.step_done": "Étape enregistrée",
  "protocols.toast.undone": "Dernière étape annulée",
  "protocols.cta.undo": "Annuler",
  "protocols.cta.undo_hint": "Annuler la dernière étape validée",
  "protocols.capture.title": "Capture guidée",
  "protocols.capture.body_area": "Zone à photographier",
  "protocols.capture.reference": "Référence d'échelle (optionnel)",
  "protocols.capture.reference.placeholder": "Ex : pièce de 1 €, règle, sticker fourni",
  "protocols.capture.pain": "Douleur (0-10)",
  "protocols.capture.redness": "Rougeur (0-5)",
  "protocols.capture.itch": "Démangeaison (0-5)",
  "protocols.capture.notes": "Ce que vous observez",
  "protocols.capture.notes.placeholder": "Quelques mots sur ce que vous voyez ou ressentez…",
  "protocols.capture.upload": "Téléverser une photo",
  "protocols.capture.take_selfie": "📷 Prendre un selfie",
  "protocols.capture.upload_short": "🖼️ Choisir une photo",
  "protocols.capture.or": "ou",
  "protocols.current_step.kicker": "Phase en cours",
  "protocols.current_step.cta": "Ajouter la photo de cette phase",
 "protocols.extension.kicker": "Prolonger le suivi",
 "protocols.extension.badge": "Bonus",
 "protocols.extension.cta": "Activer l'extension",
 "protocols.extension.preview": "Une extension sera proposée à la fin de la phase cœur :",
 "protocols.toast.extended": "Extension activée",
  "protocols.capture.checklist": "Conditions de prise de vue",
  "protocols.capture.cond.light": "Lumière naturelle, sans flash",
  "protocols.capture.cond.bg": "Fond neutre",
  "protocols.capture.cond.distance": "Distance ~30 cm, même angle qu'avant",
  "protocols.capture.cond.framing": "La zone occupe le cadre",
  "photoguide.kicker": "Guide pas à pas",
  "photoguide.title": "Comment prendre la photo et placer l'échelle",
  "photoguide.step1.title": "Lumière",
  "photoguide.step1.body": "Placez-vous face à une fenêtre. Désactivez le flash : la lumière directe écrase les reliefs et fausse les couleurs.",
  "photoguide.step2.title": "Distance",
  "photoguide.step2.body": "Tenez le téléphone à environ une longueur d'avant-bras de la zone. Reprenez le même angle qu'aux prises précédentes pour comparer.",
  "photoguide.step3.title": "Cadrage",
  "photoguide.step3.body": "La zone à suivre doit occuper l'essentiel du cadre, bien centrée et nette. Évitez les ombres portées sur la zone.",
  "photoguide.step4.title": "Référence d'échelle",
  "photoguide.step4.body": "Posez à côté de la zone un objet de taille connue : pièce de 1 €, règle, sticker de calibration. Sans toucher la zone, dans le même plan.",
  "photoguide.step4.consistency.title": "Cohérence du cadre",
  "photoguide.example.title": "Exemple réussi",
  "photoguide.example.macro.caption": "Pièce de 1 € posée à plat à ~1 cm du grain de beauté, lumière du jour douce, mise au point nette sur les deux.",
  "photoguide.example.fullbody.caption": "Plein corps centré, talons joints, mur clair derrière, téléphone à hauteur de hanche à ~2 m. Mêmes vêtements à chaque session.",
  "photoguide.example.video.caption": "Mise en place type : téléphone vertical sur un petit trépied, viseur cadré sur la silhouette.",
  "photoguide.example.face.caption": "Visage centré, cheveux dégagés, lumière naturelle douce, expression neutre. Même cadrage à chaque session.",
  "photoguide.example.scalp.caption": "Vue de dessus, raie médiane bien nette, lumière zénithale, règle souple posée à plat pour calibrer la densité.",
  "photoguide.example.smile.caption": "Sourire large, dents visibles, carte blanche tenue près de la joue pour servir de référence de teinte.",
  "photoguide.example.eyes.caption": "Cadré des sourcils aux pommettes, regard droit dans l'objectif, lumière du matin, sans maquillage.",
  "photoguide.example.back.caption": "Vue de dos plein corps, talons joints, bras le long du corps, mur clair derrière, téléphone à hauteur du nombril.",
  "photoguide.example.thighs.caption": "Vue arrière des cuisses, de la hanche au-dessus du genou, lumière rasante latérale pour révéler le relief.",
  "photoguide.example.belly.caption": "Profil entier de la poitrine aux hanches, bras légèrement écartés, lumière douce sans flash. Même tenue à chaque session.",
  "photoguide.example.acne.caption": "Joue et mâchoire en gros plan, lumière du jour diffuse de face, sans maquillage ni filtre. Quelques lésions inflammatoires visibles — la texture doit rester nette.",
  "photoguide.example.onco.caption": "Cadrage visage + cou uniquement (pas plein corps), téléphone à ~30 cm, lumière douce indirecte, expression neutre. Foulard ou bonnet OK : garde le même cadrage à chaque session.",
  "photoguide.example.scars.caption": "Cicatrice linéaire cadrée en macro, pièce de 1 € posée à plat à 1 cm. Lumière latérale douce pour révéler le relief.",
  "photoguide.example.meno_andro.caption": "Ménopause — visage à ~30 cm, cheveux dégagés, sans maquillage, lumière naturelle constante (idéalement même heure chaque session).",
  "photoguide.example.andro.caption": "Andropause — visage à ~30 cm, expression neutre, lumière de fenêtre, sans filtre. Reprends la même heure et le même mur de fond à chaque session.",
  "photoguide.example.tattoo.caption": "Tatouage cicatrisé : tout le motif + 2 cm de peau saine autour, pièce de 1 € à côté. Lumière du jour indirecte — évite les LED qui faussent les couleurs.",
  "photoguide.example.piercing.caption": "Piercing récent : centre le bijou bien net, pièce de 1 € posée à plat à côté. Lumière du jour indirecte, ne touche pas la zone.",
  "photoguide.example.sobriety.caption": "Visage face caméra à ~30 cm, expression neutre, lumière du matin. Refais la photo à la même heure pour suivre l'évolution.",
  "photoguide.example.melasma.caption": "Mélasma : taches symétriques sur pommettes, front et lèvre supérieure. Lumière du jour neutre — surtout pas de halogène qui jaunit les tons.",
  "photoguide.example.rosacea.caption": "Rosacée / peau réactive : rougeur diffuse au centre du visage (joues, nez) avec capillaires fins visibles. Lumière du jour froide et stable — la lumière chaude fausse la teinte. Sans maquillage.",
  "photoguide.example.psoriasis.caption": "Plaque d'eczéma/psoriasis bien délimitée. Cadre la plaque + 3 cm de peau saine autour, pose une pièce 1 € comme repère de taille.",
  "photoguide.example.hairgraft_before.caption": "AVANT — vue de face, lumière neutre zénithale, ligne frontale et zone donneuse visibles. Cheveux secs et bien plaqués.",
  "photoguide.example.hairgraft_after.caption": "APRÈS (m+3 à m+12) — même cadrage, même angle, même lumière qu'AVANT pour comparer densité et ligne frontale.",
  "photoguide.example.beard.caption": "Barbe — face puis profils, lumière latérale douce qui révèle la densité du poil. Sans contour ni produit coiffant.",
  "photoguide.example.brows.caption": "Sourcils & front — cadrage de la racine des cheveux aux pommettes, sans maquillage, regard droit, lumière du matin.",
  "photoguide.example.posture_front.caption": "Posture — vue de face, pieds nus, talons joints, bras le long du corps. Refaire vue de profil ET vue de dos avec exactement le même cadrage.",
  "photoguide.example.posture_back.caption": "Posture — vue de dos, mêmes appuis. La 3e photo (profil) montre l'alignement oreille-épaule-hanche-cheville.",
  "photoguide.example.pregnancy_side.caption": "Grossesse — profil entier de la poitrine aux hanches, bras légèrement écartés. C'est la vue principale pour suivre la silhouette.",
  "photoguide.example.pregnancy_front.caption": "Grossesse — vue de face en complément, mêmes vêtements moulants. Optionnel : vue de dos pour suivre les lombaires en fin de grossesse.",
  "protocols.capture.submit": "Analyser ma photo",
  "protocols.capture.analyzing": "Analyse en cours…",
  "protocols.capture.disclaimer": "Observation visuelle non médicale. Aucun diagnostic n'est posé. Pour tout doute, consultez votre praticien.",
  "protocols.capture.views.kicker": "Vues recommandées",
  "protocols.capture.views.progress": "{n} sur {total} vues capturées",
  "protocols.capture.views.next": "Vue suivante : {label}",
  "protocols.capture.views.add": "Ajouter la vue : {label}",
  "protocols.capture.views.skip": "Continuer quand même",
  "protocols.capture.views.skip.notice": "Je n'ai pas toutes les vues — je comprends que l'analyse et les recommandations seront moins précises.",
  "protocols.capture.views.missing.toast": "Vues manquantes",
  "protocols.capture.views.missing.desc": "Ajoute les vues restantes pour une analyse précise, ou coche la case « Continuer quand même ».",
  "protocols.observation.summary": "Synthèse visuelle",
  "protocols.observation.visible": "Éléments visibles",
  "protocols.observation.changes": "Évolution",
  "protocols.observation.redflags": "Signes à surveiller",
  "protocols.observation.referral": "Consultez votre praticien dans les 24-48 h",
  "protocols.observation.next": "Actions suggérées",
  "protocols.observation.quality": "Qualité de la photo",
  "protocols.observation.done": "Observation enregistrée",
  "disclaimer.banner.label": "Information importante",
  "index.specialized.kicker": "Parcours spécialisés",
  "index.specialized.title": "Un protocole adapté à votre moment de vie",
  "index.specialized.subtitle": "Des parcours guidés pour suivre votre évolution semaine après semaine, dans un cadre clair et bienveillant.",
  "index.specialized.card.kicker": "Protocole",
  "index.specialized.card.cta": "Découvrir",
  "index.specialized.all": "Voir tous les parcours",
  "app.protocol.cta.kicker": "Allez plus loin",
  "app.protocol.cta.title": "Suivez un protocole adapté à votre objectif : {0}",
  "app.protocol.cta.button": "Démarrer ce parcours",
  // Protocols — tier + lock
  "protocols.badge.pro": "Pro",
  "protocols.section.core.title": "Inclus dans votre abonnement",
  "protocols.section.pro.title": "Suivi Pro",
  "protocols.section.pro.subtitle": "Parcours dermato avancés, capillaires et spécifiques. Disponibles avec l'option Suivi Pro.",
  "protocols.locked.title": "Débloquer Suivi Pro",
  "protocols.locked.desc": "Accédez à Rosacée, Grain de beauté ABCDE, Densité capillaire, Posture et 8 autres parcours guidés.",
  "protocols.locked.cta": "Passer en Suivi Pro",
  "protocols.locked.trial": "Essai gratuit 7 jours — annulable à tout moment.",
  "protocols.locked.coming_soon": "Suivi Pro arrive très bientôt — vous serez notifié dès l'ouverture.",
  "protocols.locked.dismiss": "Plus tard",
  "protocols.referral.derma.title": "Consultation dermatologue recommandée",
  "protocols.referral.derma.desc": "Ce parcours est un outil de suivi visuel uniquement. Faites examiner cette zone par un dermatologue maintenant, puis utilisez l'app pour documenter l'évolution.",
  "protocols.referral.physician.title": "Consultation médicale recommandée",
  "protocols.referral.physician.desc": "Aucun diagnostic n'est posé ici. Faites valider votre situation par un médecin avant de poursuivre.",
  "protocols.referral.midwife.title": "Avis sage-femme / médecin recommandé",
  "protocols.referral.midwife.desc": "Pour tout doute lié à la grossesse ou au post-partum, contactez votre sage-femme ou médecin.",
  // Capture Coach
  "coach.badge.focus": "Netteté",
  "coach.badge.lighting": "Lumière",
  "coach.badge.framing": "Cadrage",
  "coach.ghost.show": "Afficher la photo précédente",
  "coach.ghost.hide": "Masquer la photo précédente",
  "coach.retake": "Reprendre une autre photo",
  "coach.pro.title": "Coach Pro — pré-vérification & burst guidé",
  "coach.pre.button": "Pré-vérifier avec l'IA",
  "coach.pre.checking": "Analyse en cours…",
  "coach.pre.score": "Score photo",
  "coach.pre.ready": "Prêt à capturer",
  "coach.pre.notready": "À améliorer",
  "coach.burst.button": "Burst guidé (3–6 photos)",
  "coach.burst.picking": "Sélection en cours…",
  "coach.burst.picked": "Meilleure photo sélectionnée",
  "coach.burst.result": "Sur {0} photos, la {1} est la plus nette",
  "coach.burst.tap_to_pick": "Touchez une vignette pour choisir une autre photo à analyser.",
  "coach.pre.quota.remaining": "{0}/{1} pré-vérifications IA restantes aujourd'hui · reset à {2}",
  "coach.pre.quota.exhausted": "Limite quotidienne atteinte — nouvelles pré-vérifications disponibles à {0}.",
  "coach.pre.quota.tooltip": "Limite de {0} pré-vérifications IA par jour pour protéger la qualité du service et maîtriser les coûts.",
  "coach.pre.err.rate_limited": "Trop de requêtes — réessayez dans quelques secondes.",
  "coach.pre.err.credits": "Crédits IA momentanément épuisés. Réessayez plus tard ou contactez le support.",
  "protocols.locked.limits.title": "À savoir avant de vous abonner",
  "protocols.locked.limits.preflight": "La pré-vérification IA des photos est limitée à 30 essais par jour et par compte. Cette limite protège la qualité du service et maîtrise les coûts IA — elle reste largement suffisante pour un suivi quotidien normal. Le burst guidé et le suivi des protocoles ne sont pas limités.",
  "protocols.locked.detail.title": "Parcours Pro — aperçu",
  "protocols.locked.detail.desc": "Vous pouvez consulter librement le contenu, les étapes et le guide photo de ce parcours. Pour le démarrer et enregistrer vos sessions, activez le Suivi Pro.",
  "protocols.locked.detail.preview": "Mode aperçu : vos photos et sessions ne sont enregistrées qu'après activation de l'abonnement.",
  "checkout.tier.premium": "Premium",
  "checkout.tier.pro": "Pro (inclut Premium)",
  "checkout.tier.pro.trial_note": "Essai gratuit de 7 jours, annulable à tout moment.",
  "notes.title": "Vos remarques (optionnel)",
  "notes.help": "Notez tout ce qui peut influencer la photo (coupe récente, coup de soleil, nouvelle crème, maquillage, mauvaise nuit…). L'IA en tiendra compte pour interpréter les changements.",
  "notes.placeholder": "Ex : nouvelle crème rétinol depuis 5 jours, week-end exposé au soleil, peu dormi…",
  "notes.action.haircut": "Coupe de cheveux",
  "notes.action.shave": "Rasage / barbe taillée",
  "notes.action.new_cream": "Nouvelle crème / sérum",
  "notes.action.sun": "Exposition soleil",
  "notes.action.treatment": "Traitement esthétique",
  "notes.action.makeup": "Maquillage / fond de teint",
  "notes.action.filter_off": "Aucun filtre",
  "notes.action.poor_sleep": "Mauvaise nuit",
  "notes.action.workout": "Sport intense récent",
  "notes.action.alcohol": "Alcool la veille",
  "notes.section_title": "Contexte que vous avez déclaré",
  "notes.add": "+ Ajouter une remarque ou une action",
  "notes.edit": "✎ Modifier mes remarques",
  "notes.modal.title": "Vos remarques sur cette analyse",
  "notes.cancel": "Annuler",
  "notes.save": "Enregistrer",
  "notes.saved": "Remarques enregistrées",
  "billing.redeem.kicker": "Code d'accès",
  "billing.redeem.title": "J'ai un code gratuit",
  "billing.redeem.help": "Si on vous a remis un code (Premium ou Pro), saisissez-le ici pour activer votre accès — sans Stripe.",
  "billing.redeem.cta": "Activer",
  "billing.redeem.success_premium": "Code activé : Premium débloqué ✨",
  "billing.redeem.success_pro": "Code activé : Pro débloqué 🚀",
};

const en: Dict = {
  "header.brand": "Glow Up Coach",
  "header.nav.method": "Methodology",
  "header.nav.premium": "Premium",
  "header.nav.billing": "My subscription",
  "index.demo.expand": "Expand",
  "index.demo.close": "Close",
  "index.demo.slider": "Before/after slider",
  "index.premium.label": "Your Premium plan",
  "index.premium.title": "You're Premium ✨",
  "index.premium.desc": "Thanks for your support. Keep tracking your progress and revisit your full history.",
  "index.premium.cta": "View my history",
  "header.nav.privacy": "Privacy",
  "header.nav.my_analysis": "My analysis",
  "header.nav.account": "Account",
  "header.nav.sign_out": "Sign out",
  "header.cta.sign_in": "Sign in",
  "header.nav.progress": "Progress",
  "header.nav.history": "History",
  "history.head.title": "Tips history — Glow Up Coach",
  "history.kicker": "Your journal",
  "history.title": "Your tips history",
  "history.subtitle": "Browse every tip generated for each analysis, and the matching selfies if you opted in to keep them.",
  "history.loading": "Loading your history…",
  "history.empty.title": "No analyses yet",
  "history.empty.desc": "Run your first analysis to start your journal.",
  "history.empty.cta": "Run an analysis",
  "history.photo_alt": "Analysis selfie",
  "history.no_photo": "Selfie not kept (no consent given)",
  "history.back": "← Back to my analysis",

  "index.head.title": "Glow Up Coach — Weekly AI photo coach",
  "index.head.desc": "One selfie a week. Our AI analyses your skin, posture and vitality. 3 actionable tips. EU-hosted.",
  "index.head.og_title": "Glow Up Coach — AI photo coach",
  "index.head.og_desc": "Weekly AI analysis of your facial progress. Private. European.",

  "index.hero.badge": "Precision Vision AI",
  "index.hero.title.start": "Your face is your best",
  "index.hero.title.accent": "biomarker.",
  "index.hero.subtitle": "One photo a week. A deep AI read of your skin, posture and vitality. Get at least 3 concrete actions to optimise your health.",
  "index.hero.cta.analyze": "Analyse my selfie",
  "slogan.highlight.kicker": "The manifesto",
  "slogan.highlight.title": "Stop filtering. Start glowing up.",
  "slogan.highlight.body": "Your AI coach reads your photos every week and guides you to your best version — the one that actually exists, off-screen.",
  "slogan.s1": "Forget Instagram filters. Every week, our AI analyses your selfies and shows you how to truly shine.",
  "slogan.s2": "Filters hide. Our AI coach reveals. One selfie a week, visible progress.",
  "slogan.s3": "In the real world, you have no filter. Luckily, you have an AI coach that makes you progress week after week.",
  "slogan.s4": "Beauty isn't applied in one click — it's built. Weekly AI photo coach, no filter, no cheating.",
  "slogan.s5": "In the real world, no filter will save you. Our AI will: weekly selfie analysis + personalised advice.",
  "slogan.s6": "The only filter you'll ever need: your own progress.",
  "index.hero.cta.demo": "See an example",
  "index.hero.privacy.eu_line1": "Data encrypted & hosted",
  "index.hero.privacy.eu_line2": "exclusively in the European Union",

  "index.demo.week_title": "Week 04 Analysis",
  "index.demo.week_goal": "Goal: Vitality & Anti-Ageing",
  "index.demo.before": "BEFORE • W01",
  "index.demo.after": "AFTER • W04",
  "index.demo.metric.skin": "Skin Glow",
  "index.demo.metric.posture": "Neck Posture",
  "index.demo.metric.eye": "Eye Rest",
  "index.demo.metric.stable": "Stable",
  "index.demo.plan.title": "The W05 Plan",
  "index.demo.plan.t1.title": "Targeted Hydration",
  "index.demo.plan.t1.text": "Add 500ml of water in the morning to reduce the under-eye puffiness we detected.",
  "index.demo.plan.t2.title": "Ergonomic Fix",
  "index.demo.plan.t2.text": "Raise your screen by 5cm. The AI detects persistent left-trapezius tension.",
  "index.demo.plan.t3.title": "Sleep Protocol",
  "index.demo.plan.t3.text": "Last meal 3h before bed. Your facial tissues show signs of active nighttime digestion.",
  "index.demo.pricing.label": "Premium",
  "index.demo.pricing.title": "Unlimited weekly analyses",
  "index.demo.pricing.desc": "Detailed plan, multi-week comparisons, smart reminders and encrypted history.",
  "index.demo.pricing.cta": "Go Premium • €4.99/mo",
  "index.demo.pricing.free": "Free: 1 analysis / month",

  "index.method.b1.title": "Objective Vision",
  "index.method.b1.text": "Your eye adapts to change. Our AI measures the millimetre-scale evolution you can't see.",
  "index.method.b2.title": "Bio-Individuality",
  "index.method.b2.text": "No generic advice. Every recommendation is based on YOUR body's physiological response.",
  "index.method.b3.title": "Total Sovereignty",
  "index.method.b3.text": "Your data never leaves Europe. No public cloud. Medical-grade privacy.",

  "index.footer.copy": "© 2026 Glow Up Coach · Built in Europe",
  "index.footer.privacy": "Privacy",
  "index.footer.premium": "Premium",

  "login.head.title": "Sign in — Glow Up Coach",
  "login.title.signin": "Sign in",
  "login.title.signup": "Create an account",
  "login.subtitle.signin": "Resume your weekly tracking.",
  "login.subtitle.signup": "Run your first analysis in 30 seconds.",
  "login.oauth.google": "Continue with Google",
  "login.oauth.apple": "Continue with Apple",
  "login.divider.or": "or",
  "login.input.email": "Email",
  "login.input.password": "Password (min. 8 characters)",
  "login.btn.signin": "Sign in",
  "login.btn.signup": "Create my account",
  "login.toggle.to_signup": "No account yet? Sign up",
  "login.toggle.to_signin": "Already registered? Sign in",
  "login.back_home": "← Back to home",
  "login.toast.check_email": "Check your email to confirm your account.",
  "login.toast.generic_error": "Error",
  "login.toast.oauth_error": "{0} error",
  "login.forgot_password": "Forgot password?",
  "forgot.head.title": "Forgot password — Glow Up Coach",
  "forgot.title": "Forgot password",
  "forgot.subtitle": "Enter your email and we'll send you a link to reset your password.",
  "forgot.input.email": "Email",
  "forgot.btn.send": "Send link",
  "forgot.toast.sent": "Email sent. Check your inbox.",
  "forgot.back_login": "← Back to sign in",
  "reset.head.title": "New password — Glow Up Coach",
  "reset.title": "New password",
  "reset.subtitle": "Choose a new password for your account.",
  "reset.input.password": "New password (min. 8 characters)",
  "reset.btn.update": "Update",
  "reset.toast.updated": "Password updated.",
  "reset.invalid_link": "Invalid or expired link. Request a new one.",

  "checkout.head.title": "Go Premium — Glow Up Coach",
  "checkout.title": "Glow Up Premium",
  "checkout.subtitle": "Unlimited analyses, detailed plan, before/after comparisons. Cancel anytime.",
  "checkout.plan.monthly.label": "Monthly",
  "checkout.plan.monthly.price_amount": "€4.99",
  "checkout.plan.monthly.price_period": "/mo",
  "checkout.plan.yearly.label": "Yearly · 2 months free",
  "checkout.plan.yearly.price_amount": "€49",
  "checkout.plan.yearly.price_period": "/yr",
  "checkout.plan.tax_badge": "incl. tax",
  "checkout.plan.tax_note": "Prices include all applicable taxes (VAT).",

  "checkout_return.head.title": "Welcome to Premium — Glow Up Coach",
  "checkout_return.title.activated": "Welcome to Premium.",
  "checkout_return.title.waiting": "Activating…",
  "checkout_return.title.received": "Payment received.",
  "checkout_return.desc.no_session": "Session not found.",
  "checkout_return.desc.activated": "Your subscription is active. Unlimited analyses unlocked.",
  "checkout_return.desc.waiting": "Confirming your subscription with Stripe (a few seconds)…",
  "checkout_return.desc.received": "Payment received. If Premium doesn't show up in a few minutes, contact support.",
  "checkout_return.cta": "Start an analysis",

  "billing.head.title": "My subscription — Glow Up Coach",
  "billing.title": "My subscription",
  "billing.subtitle": "Manage your plan and check this month's usage.",
  "billing.current_plan": "Current plan",
  "billing.plan.premium": "Premium",
  "billing.plan.free": "Free",
  "billing.badge.active": "ACTIVE",
  "billing.badge.free": "FREE",
  "billing.this_month": "This month",
  "billing.usage.premium": "analyses run",
  "billing.usage.free": "/ {0} free analysis",
  "billing.cta.manage": "Manage my subscription",
  "billing.cta.monthly": "Monthly · €4.99/mo",
  "billing.cta.yearly": "Yearly · €49/yr",
  "billing.back": "← Back to analysis",
  "billing.toast.error": "Error",
  "billing.cta.monthly_embedded": "Embedded monthly",
  "billing.cta.yearly_embedded": "Embedded yearly",
  "billing.diag.kicker": "Diagnostic",
  "billing.diag.title": "Stripe Live status",
  "billing.diag.check_cta": "Check Live status",
  "billing.diag.checking": "Checking…",
  "billing.diag.ready": "Ready",
  "billing.diag.incomplete": "Incomplete",
  "billing.diag.checked_at": "Checked at {0}",
  "billing.diag.empty": "Click “Check Live status” to query the Stripe API.",
  "billing.diag.error": "Status check failed",
  "checkout.return.head.title": "Payment confirmed — Glow Up Coach",
  "checkout.return.success.title": "Premium activated",
  "checkout.return.success.desc": "Thank you! Redirecting to your subscription…",
  "checkout.return.success.cta": "View my subscription",
  "checkout.return.pending.title": "Confirming…",
  "checkout.return.pending.desc": "We're finalizing your subscription. This takes a few seconds…",

  "account.head.title": "My account & privacy — Glow Up Coach",
  "account.head.desc": "Manage your data: export, or request permanent deletion of your selfies, analyses and history (GDPR, EU-hosted).",
  "account.label": "My account",
  "account.title": "Privacy & data",
  "account.signed_in_as": "Signed in as",
  "account.eu_note": "Hosted and processed in the",
  "account.eu": "European Union",
  "account.stored.title": "What we store",
  "account.stored.selfies": "Selfies",
  "account.stored.selfies_text": "never kept on our servers — only sent to the AI for the duration of the analysis, then deleted.",
  "account.stored.history": "Analyses & history",
  "account.stored.history_text": "AI summary, score, indicators and tips generated for each analysis.",
  "account.stored.consent": "GDPR consent",
  "account.stored.consent_text": "your storage and usage choices (in your browser).",
  "account.delete.title": "Delete all my data",
  "account.delete.desc": "Permanent and immediate deletion of all your analyses, history and consent. Irreversible action. GDPR-compliant (right to erasure, art. 17). Data processed in the EU.",
  "account.delete.done": "✓ Deletion complete",
  "account.delete.analyses_deleted": "{0} analysis/analyses deleted",
  "account.delete.sub_canceled": "Subscription {0} canceled",
  "account.delete.refund": "Prorata refund: {0} {1}",
  "account.delete.no_refund": "No refund (no period started)",
  "account.delete.no_sub": "No active subscription to cancel",
  "account.delete.region": "Region:",
  "account.delete.at": "At:",
  "account.delete.sign_out": "Sign out",
  "account.delete.request": "Request deletion",
  "account.delete.confirm_prompt": "To confirm, type",
  "account.delete.confirm_suffix": "below.",
  "account.delete.deleting": "Deleting…",
  "account.delete.confirm_btn": "Delete permanently",
  "account.delete.cancel": "Cancel",
  "account.delete.back": "← Back to my analysis",
  "account.toast.deleted": "Your data has been deleted.",
  "account.toast.error": "Deletion failed",

  "app.head.title": "My AI analysis — Glow Up Coach",
  "app.head.desc": "Upload your weekly selfie and get 3 instant personalised tips.",
  "app.usage.premium": "Premium active",
  "app.usage.free": "Free plan",
  "app.usage.this_month_premium": "{0} analyses this month",
  "app.usage.this_month_free": "{0} / {1} free analysis this month",
  "app.usage.upgrade": "Go Premium · €4.99",
  "app.step1": "Step 1 / 2",
  "app.step1.title": "Pick your goal.",
  "app.step1.desc": "The AI adapts its analysis and tips to your intent.",
  "app.goal.skin": "Skin & Glow",
  "app.goal.skin.desc": "Hydration, texture, brightness",
  "app.goal.weight": "Fitness",
  "app.goal.weight.desc": "Vitality, visible weight loss",
  "app.goal.muscle": "Muscle tone",
  "app.goal.muscle.desc": "Posture, symmetry, energy",
  "app.goal.antiaging": "Anti-ageing",
  "app.goal.antiaging.desc": "Elasticity, rest, longevity",
  "app.step2": "Step 2 / 2",
  "app.step2.title": "Upload your weekly selfie.",
  "app.step2.desc": "Natural light, face centred, neutral expression. Data processed in the EU, never stored without your consent.",
  "app.upload.prompt": "Click or drop your photo",
  "app.upload.specs": "JPG / PNG · max 45 MB",
  "app.upload.alt": "Your selfie",
  "app.result.loading": "Analysing…",
  "app.result.placeholder": "Your analysis will appear here.",
  "app.result.title": "AI Summary",
  "app.report.generating": "Generating…",
  "app.report.download": "Download my Before/After PDF report",
  "app.report.subline": "AI summary, 3 tips and week-by-week comparison.",
  "app.back_home": "← Back to home",
  "app.toast.image_too_large": "Image too large (max 45 MB)",
  "app.toast.analyze_error": "Analysis error",
  "app.toast.report_error": "Could not generate report",
  "app.toast.compressed": "Image optimised: {0} → {1}",
  "app.upload.phase.reading": "Reading file…",
  "app.upload.phase.decoding": "Decoding image…",
  "app.upload.phase.resizing": "Resizing…",
  "app.upload.phase.encoding": "Compressing…",
  "app.upload.phase.done": "Ready",
  "app.upload.phase.sending": "Sending to AI…",

  "gdpr.label": "Privacy · GDPR",
  "gdpr.title": "Your data, your choices.",
  "gdpr.intro": "Before your first analysis, tell us how you want your selfies and results handled. You can change these choices anytime from your account.",
  "gdpr.analyse.title": "Process my selfie to generate my analysis",
  "gdpr.analyse.required": "(required)",
  "gdpr.analyse.desc": "Your photo is sent to our AI to produce your personalised tips. EU-hosted.",
  "gdpr.store.title": "Keep my selfies for long-term tracking",
  "gdpr.store.optional": "(optional)",
  "gdpr.store.desc": "We keep your photos encrypted to compare your progress week by week. If unchecked, your photos are deleted immediately after analysis.",
  "gdpr.improve.title": "Use my anonymised data to improve the AI",
  "gdpr.improve.optional": "(optional)",
  "gdpr.improve.desc": "Help us refine our models. No identifying data is kept.",
  "gdpr.legal": "Under GDPR you have a right of access, rectification, objection and erasure of your data. Contact: privacy@glowupcoach.ai.",
  "gdpr.cancel": "Cancel",
  "gdpr.accept": "Accept and continue",

  "lang.label": "Language",
  "payments.test_banner.text": "Payments are in test mode in the preview.",
  "payments.test_banner.link": "Learn more",
  "progress.head.title": "My progress — Glow Up Coach",
  "progress.kicker": "Before / After",
  "progress.title": "Your glow-up, week after week",
  "progress.subtitle": "Track how your analyses evolve and review your 3 ultra-concrete tips for now.",
  "progress.loading": "Loading your progress…",
  "progress.empty.title": "No analysis yet",
  "progress.empty.desc": "Run your first analysis to start the week-by-week tracking.",
  "progress.empty.cta": "Run an analysis",
  "progress.stat.weeks": "Weeks tracked",
  "progress.stat.analyses": "Total analyses",
  "progress.stat.delta": "Score change",
  "progress.timeline.title": "Week-by-week evolution",
  "progress.tips.kicker": "To do this week",
  "progress.tips.title": "Your 3 ultra-concrete tips",
  "progress.tips.empty": "Your tips will appear here after your next analysis.",
  "progress.back_to_app": "← Back to my analysis",
  "quick.head.title": "Quick analysis — Glow Up Coach",
  "quick.kicker": "Quick analysis",
  "quick.title": "Upload a selfie, see your before / after",
  "quick.subtitle": "One goal, one photo, your before/after result in seconds.",
  "quick.upload.prompt": "Upload a selfie",
  "quick.before": "Before",
  "quick.after": "After",
  "quick.no_previous": "First analysis — no before yet",
  "quick.metrics": "Your indicators",
  "quick.tips.kicker": "Do it right now",
  "quick.tips.title": "3 ultra-concrete tips",
  "quick.retry": "Run another analysis",
  "quick.see_progress": "See my progress",
  "index.hero.cta.quick": "Analyse my selfie now",
  "index.demo.slider.hint": "Drag to compare",
  "index.demo.timeline.kicker": "4-week evolution",
  "index.demo.timeline.prev": "Previous",
  "index.demo.timeline.next": "Next",
  "index.demo.week.label": "Week {0}",
  "index.demo.week.play": "Auto play",
  "index.demo.week.pause": "Pause",
  "index.demo.subject.kicker": "Choose a profile",
  "index.demo.subject.matureMan1": "Mature man 1",
  "index.demo.subject.matureMan2": "Mature man 2",
  "index.demo.subject.midageMan1": "Middle-aged man 1",
  "index.demo.subject.midageMan2": "Middle-aged man 2",
  "index.demo.subject.youngMan1": "Young man 1",
  "index.demo.subject.youngMan2": "Young man 2",
  "index.demo.subject.matureWoman1": "Mature woman 1",
  "index.demo.subject.matureWoman2": "Mature woman 2",
  "index.demo.subject.midageWoman1": "Middle-aged woman 1",
  "index.demo.subject.midageWoman2": "Middle-aged woman 2",
  "index.demo.subject.youngWoman1": "Young woman 1",
  "index.demo.subject.youngWoman2": "Young woman 2",
  "index.demo.regen.cta": "Regenerate set",
  "index.demo.regen.loading": "Regenerating…",
  "index.demo.regen.done": "Pairs regenerated",
  "index.demo.regen.error": "Regeneration failed",
  "index.demo.qa.cta": "QA mode",
  "index.demo.qa.kicker": "Quality check",
  "index.demo.qa.loading": "Computing…",
  "index.demo.qa.hint": "Perceptual distance (dHash) between Before and each After",
  "index.demo.qa.source.asset": "Asset",
  "index.demo.qa.source.ai": "AI",
  "index.demo.qa.distance": "Distance",
  "index.demo.qa.dimensions": "Dimensions",
  "index.demo.qa.size": "Size",
  "index.demo.qa.model": "Model",
  "index.demo.qa.elapsed": "Elapsed",
  "index.demo.qa.generatedAt": "Generated at",
  "index.demo.qa.prompt": "Prompt",
  "header.nav.protocols": "Specialized tracking",
  "protocols.kicker": "Specialized tracking",
  "protocols.title": "Your guided protocols",
  "protocols.subtitle": "Follow your recovery or transition with structured, step-by-step protocols.",
  "protocols.steps": "steps",
  "protocols.badge.active": "Active",
  "protocols.badge.done": "Done",
  "protocols.cta.start": "Start this protocol",
  "protocols.cta.mark_done": "Mark done",
  "protocols.cta.add_selfie": "+ Add a selfie",
  "protocols.back": "Back to protocols",
  "protocols.not_found": "Protocol not found.",
  "protocols.toast.started": "Protocol started",
  "protocols.toast.step_done": "Step saved",
  "protocols.toast.undone": "Last step undone",
  "protocols.cta.undo": "Undo",
  "protocols.cta.undo_hint": "Undo the last completed step",
  "protocols.capture.title": "Guided capture",
  "protocols.capture.body_area": "Area to photograph",
  "protocols.capture.reference": "Scale reference (optional)",
  "protocols.capture.reference.placeholder": "e.g. 1 € coin, ruler, supplied sticker",
  "protocols.capture.pain": "Pain (0-10)",
  "protocols.capture.redness": "Redness (0-5)",
  "protocols.capture.itch": "Itch (0-5)",
  "protocols.capture.notes": "What you observe",
  "protocols.capture.notes.placeholder": "A few words about what you see or feel…",
  "protocols.capture.upload": "Upload a photo",
  "protocols.capture.take_selfie": "📷 Take a selfie",
  "protocols.capture.upload_short": "🖼️ Choose a photo",
  "protocols.capture.or": "or",
  "protocols.current_step.kicker": "Current phase",
  "protocols.current_step.cta": "Add the photo for this phase",
 "protocols.extension.kicker": "Extend the tracking",
 "protocols.extension.badge": "Bonus",
 "protocols.extension.cta": "Activate extension",
 "protocols.extension.preview": "An extension will be offered after the core phase ends:",
 "protocols.toast.extended": "Extension activated",
  "protocols.capture.checklist": "Shooting conditions",
  "protocols.capture.cond.light": "Natural light, no flash",
  "protocols.capture.cond.bg": "Neutral background",
  "protocols.capture.cond.distance": "Distance ~30 cm, same angle as before",
  "protocols.capture.cond.framing": "The area fills the frame",
  "photoguide.kicker": "Step-by-step guide",
  "photoguide.title": "How to take the photo and place a scale reference",
  "photoguide.step1.title": "Light",
  "photoguide.step1.body": "Face a window. Turn the flash off — direct flash flattens texture and shifts colours.",
  "photoguide.step2.title": "Distance",
  "photoguide.step2.body": "Hold the phone about a forearm length from the area. Reuse the same angle as previous shots so they compare.",
  "photoguide.step3.title": "Framing",
  "photoguide.step3.body": "The tracked area should fill most of the frame, well centred and sharp. Avoid shadows over it.",
  "photoguide.step4.title": "Scale reference",
  "photoguide.step4.body": "Place a known-size object next to the area: a coin, a ruler, a calibration sticker. Don't cover the area; keep both on the same plane.",
  "photoguide.step4.consistency.title": "Frame consistency",
  "photoguide.example.title": "What a good shot looks like",
  "photoguide.example.macro.caption": "1 € coin laid flat ~1 cm from the mole, soft daylight, both in sharp focus.",
  "photoguide.example.fullbody.caption": "Full body centred, heels together, plain wall behind, phone at hip height ~2 m away. Same outfit every session.",
  "photoguide.example.video.caption": "Typical setup: phone vertical on a small tripod, viewfinder framing the silhouette.",
  "photoguide.example.face.caption": "Face centred, hair tied back, soft daylight, neutral expression. Same framing every session.",
  "photoguide.example.scalp.caption": "Top-down view, midline parting sharp, overhead light, soft ruler laid flat to calibrate density.",
  "photoguide.example.smile.caption": "Wide smile, teeth visible, white card held next to the cheek as a shade reference.",
  "photoguide.example.eyes.caption": "Framed brows to cheekbones, eyes straight into the lens, morning light, no makeup.",
  "photoguide.example.back.caption": "Full back view, heels together, arms relaxed, plain wall behind, phone at belly-button height.",
  "photoguide.example.thighs.caption": "Back view of thighs, hip to above the knee, raking side light to reveal skin relief.",
  "photoguide.example.belly.caption": "Full side profile chest to hips, arms slightly out, soft light no flash. Same outfit every session.",
  "photoguide.example.acne.caption": "Cheek and jawline close-up, diffuse daylight from the front, no makeup or filter. A few inflammatory lesions visible — texture must stay sharp.",
  "photoguide.example.onco.caption": "Face and neck only (not full body), phone at ~30 cm, soft indirect light, neutral expression. Headscarf or cap is fine — keep the same framing every session.",
  "photoguide.example.scars.caption": "Macro framing of a linear scar with a 1€ coin flat 1 cm away. Soft side light reveals the scar's relief.",
  "photoguide.example.meno_andro.caption": "Menopause — face at ~30 cm, hair pulled back, no makeup, consistent natural light (ideally same time of day each session).",
  "photoguide.example.andro.caption": "Andropause — face at ~30 cm, neutral expression, window light, no filter. Reuse the same time and same wall every session.",
  "photoguide.example.tattoo.caption": "Healed tattoo: whole design + 2 cm of clear skin around it, 1€ coin next to it. Indirect daylight — avoid LEDs that distort ink colours.",
  "photoguide.example.piercing.caption": "Recent piercing: center the jewelry sharply, 1€ coin laid flat next to it. Indirect daylight, don't touch the area.",
  "photoguide.example.sobriety.caption": "Face straight to camera at ~30 cm, neutral expression, morning light. Shoot at the same time each session to track change.",
  "photoguide.example.melasma.caption": "Melasma — symmetrical patches on cheekbones, forehead and upper lip. Neutral daylight only — avoid halogen which yellows the tones.",
  "photoguide.example.rosacea.caption": "Rosacea / reactive skin: diffuse central facial redness (cheeks, nose) with fine visible capillaries. Cool, steady daylight only — warm light biases the tone. No makeup.",
  "photoguide.example.psoriasis.caption": "Eczema/psoriasis plaque, well demarcated. Frame the plaque + 3 cm of clear skin around it, place a 1€ coin as size reference.",
  "photoguide.example.hairgraft_before.caption": "BEFORE — front view, neutral overhead light, hairline and donor area visible. Dry hair, combed flat.",
  "photoguide.example.hairgraft_after.caption": "AFTER (m+3 to m+12) — same framing, same angle, same light as BEFORE to compare density and hairline.",
  "photoguide.example.beard.caption": "Beard — front then profiles, soft side light reveals hair density. No styling product, no shaping.",
  "photoguide.example.brows.caption": "Brows & forehead — frame from hairline to cheekbones, no makeup, straight gaze, morning light.",
  "photoguide.example.posture_front.caption": "Posture — front view, bare feet, heels together, arms at sides. Repeat side view AND back view with the same framing.",
  "photoguide.example.posture_back.caption": "Posture — back view, same stance. The 3rd photo (side) shows ear–shoulder–hip–ankle alignment.",
  "photoguide.example.pregnancy_side.caption": "Pregnancy — full side profile chest to hips, arms slightly out. This is the main view to track silhouette change.",
  "photoguide.example.pregnancy_front.caption": "Pregnancy — front view as a complement, same fitted clothing. Optional: back view to track lower-back curve later on.",
  "protocols.capture.submit": "Analyse my photo",
  "protocols.capture.analyzing": "Analysing…",
  "protocols.capture.disclaimer": "Non-medical visual observation. No diagnosis is made. If in doubt, consult your practitioner.",
  "protocols.capture.views.kicker": "Recommended views",
  "protocols.capture.views.progress": "{n} of {total} views captured",
  "protocols.capture.views.next": "Next view: {label}",
  "protocols.capture.views.add": "Add view: {label}",
  "protocols.capture.views.skip": "Continue anyway",
  "protocols.capture.views.skip.notice": "I don't have every view — I understand the analysis and recommendations will be less precise.",
  "protocols.capture.views.missing.toast": "Missing views",
  "protocols.capture.views.missing.desc": "Add the remaining views for a precise analysis, or tick the « Continue anyway » box.",
  "protocols.observation.summary": "Visual summary",
  "protocols.observation.visible": "Visible elements",
  "protocols.observation.changes": "Change vs previous",
  "protocols.observation.redflags": "Watch-out cues",
  "protocols.observation.referral": "See your practitioner within 24-48h",
  "protocols.observation.next": "Suggested actions",
  "protocols.observation.quality": "Photo quality",
  "protocols.observation.done": "Observation saved",
  "disclaimer.banner.label": "Important notice",
  "index.specialized.kicker": "Specialized journeys",
  "index.specialized.title": "A protocol tailored to your life moment",
  "index.specialized.subtitle": "Guided journeys to track your progress week after week, in a clear and supportive framework.",
  "index.specialized.card.kicker": "Protocol",
  "index.specialized.card.cta": "Discover",
  "index.specialized.all": "See all journeys",
  "app.protocol.cta.kicker": "Go further",
  "app.protocol.cta.title": "Follow a protocol tailored to your goal: {0}",
  "app.protocol.cta.button": "Start this journey",
  // Protocols — tier + lock
  "protocols.badge.pro": "Pro",
  "protocols.section.core.title": "Included in your plan",
  "protocols.section.pro.title": "Pro Tracking",
  "protocols.section.pro.subtitle": "Advanced derma, hair and specialised journeys. Available with the Pro Tracking add-on.",
  "protocols.locked.title": "Unlock Pro Tracking",
  "protocols.locked.desc": "Access Rosacea, ABCDE mole tracking, Hair density, Posture and 8 more guided protocols.",
  "protocols.locked.cta": "Upgrade to Pro Tracking",
  "protocols.locked.trial": "7-day free trial — cancel anytime.",
  "protocols.locked.coming_soon": "Pro Tracking is coming soon — you'll be notified at launch.",
  "protocols.locked.dismiss": "Later",
  "protocols.referral.derma.title": "Dermatologist visit recommended",
  "protocols.referral.derma.desc": "This journey is a visual tracking tool only. Have this area examined by a dermatologist now, then use the app to document its evolution.",
  "protocols.referral.physician.title": "Physician consultation recommended",
  "protocols.referral.physician.desc": "No diagnosis is made here. Have your situation validated by a physician before continuing.",
  "protocols.referral.midwife.title": "Midwife / physician advice recommended",
  "protocols.referral.midwife.desc": "For any pregnancy or post-partum concern, contact your midwife or physician.",
  // Capture Coach
  "coach.badge.focus": "Sharpness",
  "coach.badge.lighting": "Lighting",
  "coach.badge.framing": "Framing",
  "coach.ghost.show": "Show previous photo",
  "coach.ghost.hide": "Hide previous photo",
  "coach.retake": "Pick another photo",
  "coach.pro.title": "Pro Coach — pre-check & guided burst",
  "coach.pre.button": "AI pre-check",
  "coach.pre.checking": "Analyzing…",
  "coach.pre.score": "Shot score",
  "coach.pre.ready": "Ready to shoot",
  "coach.pre.notready": "Needs improvement",
  "coach.burst.button": "Guided burst (3–6 shots)",
  "coach.burst.picking": "Picking best frame…",
  "coach.burst.picked": "Best frame selected",
  "coach.burst.result": "Out of {0} frames, #{1} is the sharpest",
  "coach.burst.tap_to_pick": "Tap a thumbnail to pick a different frame for analysis.",
  "coach.pre.quota.remaining": "{0}/{1} AI pre-checks left today · resets at {2}",
  "coach.pre.quota.exhausted": "Daily limit reached — new pre-checks available at {0}.",
  "coach.pre.quota.tooltip": "Capped at {0} AI pre-checks per day to keep service quality high and AI costs in check.",
  "coach.pre.err.rate_limited": "Too many requests — please retry in a few seconds.",
  "coach.pre.err.credits": "AI credits temporarily exhausted. Try again later or contact support.",
  "protocols.locked.limits.title": "Good to know before subscribing",
  "protocols.locked.limits.preflight": "AI photo pre-check is capped at 30 attempts per day per account. This protects service quality and keeps AI costs sustainable — it's well above normal daily tracking use. Guided burst and protocol tracking are not capped.",
  "protocols.locked.detail.title": "Pro protocol — preview",
  "protocols.locked.detail.desc": "You can freely browse the content, the steps and the photo guide of this protocol. To actually start it and save your sessions, activate Pro Tracking.",
  "protocols.locked.detail.preview": "Preview mode: photos and sessions are saved only after activating the subscription.",
  "checkout.tier.premium": "Premium",
  "checkout.tier.pro": "Pro (includes Premium)",
  "checkout.tier.pro.trial_note": "7-day free trial, cancel anytime.",
  "notes.title": "Your notes (optional)",
  "notes.help": "Mention anything that may affect the photo (recent haircut, sunburn, new cream, makeup, poor sleep…). The AI will use this to interpret variations.",
  "notes.placeholder": "E.g. new retinol cream for 5 days, sunny weekend, slept poorly…",
  "notes.action.haircut": "Haircut",
  "notes.action.shave": "Shave / beard trim",
  "notes.action.new_cream": "New cream / serum",
  "notes.action.sun": "Sun exposure",
  "notes.action.treatment": "Aesthetic treatment",
  "notes.action.makeup": "Makeup / foundation",
  "notes.action.filter_off": "No filter",
  "notes.action.poor_sleep": "Poor sleep",
  "notes.action.workout": "Recent intense workout",
  "notes.action.alcohol": "Alcohol last night",
  "notes.section_title": "Context you declared",
  "notes.add": "+ Add a note or action",
  "notes.edit": "✎ Edit my notes",
  "notes.modal.title": "Your notes on this analysis",
  "notes.cancel": "Cancel",
  "notes.save": "Save",
  "notes.saved": "Notes saved",
  "billing.redeem.kicker": "Access code",
  "billing.redeem.title": "I have a free code",
  "billing.redeem.help": "If you were given a code (Premium or Pro), enter it here to unlock access — no Stripe needed.",
  "billing.redeem.cta": "Activate",
  "billing.redeem.success_premium": "Code activated: Premium unlocked ✨",
  "billing.redeem.success_pro": "Code activated: Pro unlocked 🚀",
};

const nl: Dict = {
  "header.brand": "Glow Up Coach",
  "header.nav.method": "Methodologie",
  "header.nav.premium": "Premium",
  "header.nav.billing": "Mijn abonnement",
  "index.demo.expand": "Vergroten",
  "index.demo.close": "Sluiten",
  "index.demo.slider": "Voor/na schuifregelaar",
  "index.premium.label": "Jouw Premium-abonnement",
  "index.premium.title": "Je bent Premium ✨",
  "index.premium.desc": "Bedankt voor je steun. Blijf je voortgang volgen en bekijk je volledige geschiedenis.",
  "index.premium.cta": "Bekijk mijn geschiedenis",
  "header.nav.privacy": "Privacy",
  "header.nav.my_analysis": "Mijn analyse",
  "header.nav.account": "Account",
  "header.nav.sign_out": "Afmelden",
  "header.cta.sign_in": "Inloggen",
  "header.nav.progress": "Voortgang",
  "header.nav.history": "Geschiedenis",
  "history.head.title": "Tipsgeschiedenis — Glow Up Coach",
  "history.kicker": "Je dagboek",
  "history.title": "Je tipsgeschiedenis",
  "history.subtitle": "Bekijk alle tips die bij elke analyse zijn gegenereerd, en de bijhorende selfies als je hun bewaring hebt geactiveerd.",
  "history.loading": "Geschiedenis laden…",
  "history.empty.title": "Nog geen analyses",
  "history.empty.desc": "Voer je eerste analyse uit om je dagboek te starten.",
  "history.empty.cta": "Analyse uitvoeren",
  "history.photo_alt": "Selfie van de analyse",
  "history.no_photo": "Selfie niet bewaard (geen toestemming gegeven)",
  "history.back": "← Terug naar mijn analyse",

  "index.head.title": "Glow Up Coach — Wekelijkse AI-fotocoach",
  "index.head.desc": "Eén selfie per week. Onze AI analyseert je huid, houding en vitaliteit. Minstens 3 concrete tips. Gehost in de EU.",
  "index.head.og_title": "Glow Up Coach — AI-fotocoach",
  "index.head.og_desc": "Wekelijkse AI-analyse van je gezichtsevolutie. Privé. Europees.",

  "index.hero.badge": "Precisie Vision AI",
  "index.hero.title.start": "Je gezicht is je beste",
  "index.hero.title.accent": "biomarker.",
  "index.hero.subtitle": "Eén foto per week. Een diepgaande AI-analyse van je huid, houding en vitaliteit. Krijg minstens 3 concrete acties om je gezondheid te optimaliseren.",
  "index.hero.cta.analyze": "Mijn selfie analyseren",
  "slogan.highlight.kicker": "Het manifest",
  "slogan.highlight.title": "Stop met filteren. Begin met glow-up.",
  "slogan.highlight.body": "Je AI-coach analyseert je foto's elke week en begeleidt je naar je beste versie — die welke écht bestaat, buiten het scherm.",
  "slogan.s1": "Vergeet Instagram-filters. Elke week analyseert onze AI je selfies en laat zien hoe je écht straalt.",
  "slogan.s2": "Filters verbergen. Onze AI-coach onthult. Eén selfie per week, zichtbare vooruitgang.",
  "slogan.s3": "In de echte wereld heb je geen filter. Gelukkig heb je een AI-coach die je week na week vooruit helpt.",
  "slogan.s4": "Schoonheid pas je niet aan met één klik — je bouwt ze op. Wekelijkse AI-fotocoach, zonder filter, zonder trucs.",
  "slogan.s5": "In de echte wereld redt geen filter je. Onze AI wel: wekelijkse selfie-analyse + persoonlijk advies.",
  "slogan.s6": "Het enige filter dat je nodig hebt: je eigen vooruitgang.",
  "index.hero.cta.demo": "Bekijk een voorbeeld",
  "index.hero.privacy.eu_line1": "Versleutelde gegevens, gehost",
  "index.hero.privacy.eu_line2": "uitsluitend in de Europese Unie",

  "index.demo.week_title": "Analyse week 04",
  "index.demo.week_goal": "Doel: vitaliteit & anti-veroudering",
  "index.demo.before": "VOOR • W01",
  "index.demo.after": "NA • W04",
  "index.demo.metric.skin": "Huidglans",
  "index.demo.metric.posture": "Nekhouding",
  "index.demo.metric.eye": "Oogrust",
  "index.demo.metric.stable": "Stabiel",
  "index.demo.plan.title": "Het W05-plan",
  "index.demo.plan.t1.title": "Gerichte hydratatie",
  "index.demo.plan.t1.text": "Verhoog je waterinname met 500 ml 's ochtends om de wallen onder je ogen te verminderen.",
  "index.demo.plan.t2.title": "Ergonomische correctie",
  "index.demo.plan.t2.text": "Verhoog je scherm met 5 cm. De AI ziet aanhoudende spanning in de linker trapezius.",
  "index.demo.plan.t3.title": "Slaapprotocol",
  "index.demo.plan.t3.text": "Laatste maaltijd 3 u vóór het slapen. Je gezichtsweefsel toont tekenen van actieve nachtelijke vertering.",
  "index.demo.pricing.label": "Premium",
  "index.demo.pricing.title": "Onbeperkte wekelijkse analyses",
  "index.demo.pricing.desc": "Gedetailleerd plan, vergelijkingen over meerdere weken, slimme herinneringen en versleutelde geschiedenis.",
  "index.demo.pricing.cta": "Upgrade naar Premium • € 4,99/maand",
  "index.demo.pricing.free": "Gratis: 1 analyse / maand",

  "index.method.b1.title": "Objectieve blik",
  "index.method.b1.text": "Het menselijk oog went aan verandering. Onze AI meet de millimetrische evolutie die je niet kunt zien.",
  "index.method.b2.title": "Bio-individualiteit",
  "index.method.b2.text": "Geen generieke adviezen. Elke aanbeveling is gebaseerd op de fysiologische reactie van JOUW lichaam.",
  "index.method.b3.title": "Volledige soevereiniteit",
  "index.method.b3.text": "Je gegevens verlaten Europa nooit. Geen publieke cloud. Privacy op medisch niveau.",

  "index.footer.copy": "© 2026 Glow Up Coach · Ontwikkeld in Europa",
  "index.footer.privacy": "Privacy",
  "index.footer.premium": "Premium",

  "login.head.title": "Inloggen — Glow Up Coach",
  "login.title.signin": "Inloggen",
  "login.title.signup": "Account aanmaken",
  "login.subtitle.signin": "Hervat je wekelijkse opvolging.",
  "login.subtitle.signup": "Start je eerste analyse in 30 seconden.",
  "login.oauth.google": "Doorgaan met Google",
  "login.oauth.apple": "Doorgaan met Apple",
  "login.divider.or": "of",
  "login.input.email": "E-mail",
  "login.input.password": "Wachtwoord (min. 8 tekens)",
  "login.btn.signin": "Inloggen",
  "login.btn.signup": "Mijn account aanmaken",
  "login.toggle.to_signup": "Nog geen account? Registreren",
  "login.toggle.to_signin": "Al geregistreerd? Inloggen",
  "login.back_home": "← Terug naar home",
  "login.toast.check_email": "Bekijk je e-mail om je account te bevestigen.",
  "login.toast.generic_error": "Fout",
  "login.toast.oauth_error": "Fout {0}",
  "login.forgot_password": "Wachtwoord vergeten?",
  "forgot.head.title": "Wachtwoord vergeten — Glow Up Coach",
  "forgot.title": "Wachtwoord vergeten",
  "forgot.subtitle": "Voer je e-mail in, we sturen je een link om je wachtwoord opnieuw in te stellen.",
  "forgot.input.email": "E-mail",
  "forgot.btn.send": "Link sturen",
  "forgot.toast.sent": "E-mail verzonden. Controleer je inbox.",
  "forgot.back_login": "← Terug naar inloggen",
  "reset.head.title": "Nieuw wachtwoord — Glow Up Coach",
  "reset.title": "Nieuw wachtwoord",
  "reset.subtitle": "Kies een nieuw wachtwoord voor je account.",
  "reset.input.password": "Nieuw wachtwoord (min. 8 tekens)",
  "reset.btn.update": "Bijwerken",
  "reset.toast.updated": "Wachtwoord bijgewerkt.",
  "reset.invalid_link": "Ongeldige of verlopen link. Vraag een nieuwe aan.",

  "checkout.head.title": "Upgrade naar Premium — Glow Up Coach",
  "checkout.title": "Glow Up Premium",
  "checkout.subtitle": "Onbeperkte analyses, gedetailleerd plan, voor/na vergelijkingen. Annuleer wanneer je wilt.",
  "checkout.plan.monthly.label": "Maandelijks",
  "checkout.plan.monthly.price_amount": "€ 4,99",
  "checkout.plan.monthly.price_period": "/maand",
  "checkout.plan.yearly.label": "Jaarlijks · 2 maanden gratis",
  "checkout.plan.yearly.price_amount": "€ 49",
  "checkout.plan.yearly.price_period": "/jaar",
  "checkout.plan.tax_badge": "incl. btw",
  "checkout.plan.tax_note": "Prijzen inclusief alle toepasselijke belastingen (btw).",

  "checkout_return.head.title": "Welkom bij Premium — Glow Up Coach",
  "checkout_return.title.activated": "Welkom bij Premium.",
  "checkout_return.title.waiting": "Bezig met activeren…",
  "checkout_return.title.received": "Betaling ontvangen.",
  "checkout_return.desc.no_session": "Sessie niet gevonden.",
  "checkout_return.desc.activated": "Je abonnement is actief. Onbeperkte analyses ontgrendeld.",
  "checkout_return.desc.waiting": "We bevestigen je abonnement bij Stripe (een paar seconden)…",
  "checkout_return.desc.received": "Betaling ontvangen. Verschijnt Premium niet binnen enkele minuten? Neem contact op met support.",
  "checkout_return.cta": "Start een analyse",

  "billing.head.title": "Mijn abonnement — Glow Up Coach",
  "billing.title": "Mijn abonnement",
  "billing.subtitle": "Beheer je plan en bekijk je gebruik van deze maand.",
  "billing.current_plan": "Huidig plan",
  "billing.plan.premium": "Premium",
  "billing.plan.free": "Gratis",
  "billing.badge.active": "ACTIEF",
  "billing.badge.free": "GRATIS",
  "billing.this_month": "Deze maand",
  "billing.usage.premium": "uitgevoerde analyses",
  "billing.usage.free": "/ {0} gratis analyse",
  "billing.cta.manage": "Mijn abonnement beheren",
  "billing.cta.monthly": "Maandelijks · € 4,99/maand",
  "billing.cta.yearly": "Jaarlijks · € 49/jaar",
  "billing.back": "← Terug naar analyse",
  "billing.toast.error": "Fout",
  "billing.cta.monthly_embedded": "Maandelijks (ingebed)",
  "billing.cta.yearly_embedded": "Jaarlijks (ingebed)",
  "billing.diag.kicker": "Diagnose",
  "billing.diag.title": "Stripe Live-status",
  "billing.diag.check_cta": "Live-status controleren",
  "billing.diag.checking": "Controleren…",
  "billing.diag.ready": "Klaar",
  "billing.diag.incomplete": "Onvolledig",
  "billing.diag.checked_at": "Gecontroleerd om {0}",
  "billing.diag.empty": "Klik op “Live-status controleren” om de Stripe-API te bevragen.",
  "billing.diag.error": "Statuscontrole mislukt",
  "checkout.return.head.title": "Betaling bevestigd — Glow Up Coach",
  "checkout.return.success.title": "Premium geactiveerd",
  "checkout.return.success.desc": "Bedankt! Je wordt doorgestuurd naar je abonnement…",
  "checkout.return.success.cta": "Mijn abonnement bekijken",
  "checkout.return.pending.title": "Bevestiging bezig",
  "checkout.return.pending.desc": "We ronden je abonnement af. Dit duurt enkele seconden…",

  "account.head.title": "Mijn account & privacy — Glow Up Coach",
  "account.head.desc": "Beheer je gegevens: exporteer of vraag de definitieve verwijdering van je selfies, analyses en geschiedenis (AVG, EU-hosting).",
  "account.label": "Mijn account",
  "account.title": "Privacy & gegevens",
  "account.signed_in_as": "Ingelogd als",
  "account.eu_note": "Gehost en verwerkt in de",
  "account.eu": "Europese Unie",
  "account.stored.title": "Wat we opslaan",
  "account.stored.selfies": "Selfies",
  "account.stored.selfies_text": "nooit bewaard op onze servers — alleen tijdens de analyse naar de AI gestuurd en daarna verwijderd.",
  "account.stored.history": "Analyses & geschiedenis",
  "account.stored.history_text": "AI-samenvatting, score, indicatoren en tips die per analyse worden gegenereerd.",
  "account.stored.consent": "AVG-toestemming",
  "account.stored.consent_text": "je opslag- en gebruikskeuzes (in je browser).",
  "account.delete.title": "Al mijn gegevens verwijderen",
  "account.delete.desc": "Definitieve en directe verwijdering van al je analyses, geschiedenis en toestemming. Onomkeerbare actie. AVG-conform (recht op wissen, art. 17). Gegevens verwerkt in de EU.",
  "account.delete.done": "✓ Verwijdering voltooid",
  "account.delete.analyses_deleted": "{0} analyse(s) verwijderd",
  "account.delete.sub_canceled": "Abonnement {0} geannuleerd",
  "account.delete.refund": "Pro-rata terugbetaling: {0} {1}",
  "account.delete.no_refund": "Geen terugbetaling (geen periode gestart)",
  "account.delete.no_sub": "Geen actief abonnement om te annuleren",
  "account.delete.region": "Regio:",
  "account.delete.at": "Op:",
  "account.delete.sign_out": "Afmelden",
  "account.delete.request": "Verwijdering aanvragen",
  "account.delete.confirm_prompt": "Typ ter bevestiging",
  "account.delete.confirm_suffix": "hieronder.",
  "account.delete.deleting": "Verwijderen…",
  "account.delete.confirm_btn": "Definitief verwijderen",
  "account.delete.cancel": "Annuleren",
  "account.delete.back": "← Terug naar mijn analyse",
  "account.toast.deleted": "Je gegevens zijn verwijderd.",
  "account.toast.error": "Verwijdering mislukt",

  "app.head.title": "Mijn AI-analyse — Glow Up Coach",
  "app.head.desc": "Upload je wekelijkse selfie en krijg direct 3 gepersonaliseerde tips.",
  "app.usage.premium": "Premium actief",
  "app.usage.free": "Gratis plan",
  "app.usage.this_month_premium": "{0} analyses deze maand",
  "app.usage.this_month_free": "{0} / {1} gratis analyse deze maand",
  "app.usage.upgrade": "Upgrade Premium · € 4,99",
  "app.step1": "Stap 1 / 2",
  "app.step1.title": "Kies je doel.",
  "app.step1.desc": "De AI past de analyse en tips aan jouw intentie aan.",
  "app.goal.skin": "Huid & glans",
  "app.goal.skin.desc": "Hydratatie, textuur, helderheid",
  "app.goal.weight": "Fitheid",
  "app.goal.weight.desc": "Vitaliteit, zichtbaar gewichtsverlies",
  "app.goal.muscle": "Spiertonus",
  "app.goal.muscle.desc": "Houding, symmetrie, energie",
  "app.goal.antiaging": "Anti-veroudering",
  "app.goal.antiaging.desc": "Elasticiteit, rust, levensduur",
  "app.step2": "Stap 2 / 2",
  "app.step2.title": "Upload je wekelijkse selfie.",
  "app.step2.desc": "Natuurlijk licht, gezicht gecentreerd, neutrale uitdrukking. Gegevens verwerkt in de EU, nooit opgeslagen zonder je toestemming.",
  "app.upload.prompt": "Klik of sleep je foto",
  "app.upload.specs": "JPG / PNG · max 45 MB",
  "app.upload.alt": "Jouw selfie",
  "app.result.loading": "Bezig met analyseren…",
  "app.result.placeholder": "Je analyse verschijnt hier.",
  "app.result.title": "AI-samenvatting",
  "app.report.generating": "Bezig met genereren…",
  "app.report.download": "Download mijn voor/na PDF-rapport",
  "app.report.subline": "AI-samenvatting, 3 tips en week-per-week vergelijking.",
  "app.back_home": "← Terug naar home",
  "app.toast.image_too_large": "Afbeelding te groot (max 45 MB)",
  "app.toast.analyze_error": "Analysefout",
  "app.toast.report_error": "Kan rapport niet genereren",
  "app.toast.compressed": "Afbeelding geoptimaliseerd: {0} → {1}",
  "app.upload.phase.reading": "Bestand lezen…",
  "app.upload.phase.decoding": "Beeld decoderen…",
  "app.upload.phase.resizing": "Verkleinen…",
  "app.upload.phase.encoding": "Comprimeren…",
  "app.upload.phase.done": "Klaar",
  "app.upload.phase.sending": "Versturen naar AI…",

  "gdpr.label": "Privacy · AVG",
  "gdpr.title": "Jouw gegevens, jouw keuzes.",
  "gdpr.intro": "Vertel ons vóór je eerste analyse hoe we je selfies en resultaten moeten behandelen. Je kunt deze keuzes op elk moment in je account aanpassen.",
  "gdpr.analyse.title": "Mijn selfie verwerken om mijn analyse te genereren",
  "gdpr.analyse.required": "(verplicht)",
  "gdpr.analyse.desc": "Je foto wordt naar onze AI gestuurd om je persoonlijke tips te genereren. EU-hosting.",
  "gdpr.store.title": "Mijn selfies bewaren voor langetermijn-opvolging",
  "gdpr.store.optional": "(optioneel)",
  "gdpr.store.desc": "We bewaren je foto's versleuteld om je voortgang week na week te vergelijken. Indien uitgevinkt worden je foto's direct na de analyse verwijderd.",
  "gdpr.improve.title": "Mijn geanonimiseerde gegevens gebruiken om de AI te verbeteren",
  "gdpr.improve.optional": "(optioneel)",
  "gdpr.improve.desc": "Help ons onze modellen te verfijnen. Geen identificerende gegevens worden bewaard.",
  "gdpr.legal": "Onder de AVG heb je recht op inzage, rectificatie, bezwaar en verwijdering van je gegevens. Contact: privacy@glowupcoach.ai.",
  "gdpr.cancel": "Annuleren",
  "gdpr.accept": "Aanvaarden en doorgaan",

  "lang.label": "Taal",
  "payments.test_banner.text": "Betalingen staan in testmodus in de preview.",
  "payments.test_banner.link": "Meer informatie",
  "progress.head.title": "Mijn voortgang — Glow Up Coach",
  "progress.kicker": "Voor / Na",
  "progress.title": "Jouw glow-up, week na week",
  "progress.subtitle": "Volg hoe je analyses evolueren en bekijk je 3 ultra-concrete tips van dit moment.",
  "progress.loading": "Voortgang laden…",
  "progress.empty.title": "Nog geen analyse",
  "progress.empty.desc": "Start je eerste analyse om je wekelijkse voortgang te volgen.",
  "progress.empty.cta": "Analyse starten",
  "progress.stat.weeks": "Weken gevolgd",
  "progress.stat.analyses": "Totaal aantal analyses",
  "progress.stat.delta": "Score-evolutie",
  "progress.timeline.title": "Evolutie week per week",
  "progress.tips.kicker": "Te doen deze week",
  "progress.tips.title": "Jouw 3 ultra-concrete tips",
  "progress.tips.empty": "Je tips verschijnen hier na je volgende analyse.",
  "progress.back_to_app": "← Terug naar mijn analyse",
  "quick.head.title": "Snelle analyse — Glow Up Coach",
  "quick.kicker": "Snelle analyse",
  "quick.title": "Upload een selfie en zie het voor / na",
  "quick.subtitle": "Eén doel, één foto, je voor/na-resultaat in enkele seconden.",
  "quick.upload.prompt": "Selfie uploaden",
  "quick.before": "Voor",
  "quick.after": "Na",
  "quick.no_previous": "Eerste analyse — nog geen voor",
  "quick.metrics": "Je indicatoren",
  "quick.tips.kicker": "Nu doen",
  "quick.tips.title": "3 ultra-concrete tips",
  "quick.retry": "Nieuwe analyse",
  "quick.see_progress": "Mijn voortgang bekijken",
  "index.hero.cta.quick": "Analyseer mijn selfie nu",
  "index.demo.slider.hint": "Sleep om te vergelijken",
  "index.demo.timeline.kicker": "Evolutie over 4 weken",
  "index.demo.timeline.prev": "Vorige",
  "index.demo.timeline.next": "Volgende",
  "index.demo.week.label": "Week {0}",
  "index.demo.week.play": "Auto afspelen",
  "index.demo.week.pause": "Pauze",
  "index.demo.subject.kicker": "Kies een profiel",
  "index.demo.subject.matureMan1": "Rijpere man 1",
  "index.demo.subject.matureMan2": "Rijpere man 2",
  "index.demo.subject.midageMan1": "Man middelbare leeftijd 1",
  "index.demo.subject.midageMan2": "Man middelbare leeftijd 2",
  "index.demo.subject.youngMan1": "Jonge man 1",
  "index.demo.subject.youngMan2": "Jonge man 2",
  "index.demo.subject.matureWoman1": "Rijpere vrouw 1",
  "index.demo.subject.matureWoman2": "Rijpere vrouw 2",
  "index.demo.subject.midageWoman1": "Vrouw middelbare leeftijd 1",
  "index.demo.subject.midageWoman2": "Vrouw middelbare leeftijd 2",
  "index.demo.subject.youngWoman1": "Jonge vrouw 1",
  "index.demo.subject.youngWoman2": "Jonge vrouw 2",
  "index.demo.regen.cta": "Set opnieuw genereren",
  "index.demo.regen.loading": "Bezig…",
  "index.demo.regen.done": "Paren opnieuw gegenereerd",
  "index.demo.regen.error": "Genereren mislukt",
  "index.demo.qa.cta": "QA-modus",
  "index.demo.qa.kicker": "Kwaliteitscontrole",
  "index.demo.qa.loading": "Berekenen…",
  "index.demo.qa.hint": "Perceptuele afstand (dHash) tussen Voor en elke Na",
  "index.demo.qa.source.asset": "Asset",
  "index.demo.qa.source.ai": "AI",
  "index.demo.qa.distance": "Afstand",
  "index.demo.qa.dimensions": "Afmetingen",
  "index.demo.qa.size": "Grootte",
  "index.demo.qa.model": "Model",
  "index.demo.qa.elapsed": "Duur",
  "index.demo.qa.generatedAt": "Gegenereerd om",
  "index.demo.qa.prompt": "Prompt",
  "header.nav.protocols": "Gespecialiseerde opvolging",
  "protocols.kicker": "Gespecialiseerde opvolging",
  "protocols.title": "Jouw geleide protocollen",
  "protocols.subtitle": "Volg je herstel of overgang stap voor stap.",
  "protocols.steps": "stappen",
  "protocols.badge.active": "Actief",
  "protocols.badge.done": "Klaar",
  "protocols.cta.start": "Start dit protocol",
  "protocols.cta.mark_done": "Markeer als gedaan",
  "protocols.cta.add_selfie": "+ Selfie toevoegen",
  "protocols.back": "Terug naar protocollen",
  "protocols.not_found": "Protocol niet gevonden.",
  "protocols.toast.started": "Protocol gestart",
  "protocols.toast.step_done": "Stap opgeslagen",
  "protocols.toast.undone": "Laatste stap ongedaan gemaakt",
  "protocols.cta.undo": "Ongedaan maken",
  "protocols.cta.undo_hint": "De laatst voltooide stap ongedaan maken",
  "protocols.capture.title": "Geleide opname",
  "protocols.capture.body_area": "Te fotograferen zone",
  "protocols.capture.reference": "Schaalreferentie (optioneel)",
  "protocols.capture.reference.placeholder": "Bv. munt van € 1, liniaal, sticker",
  "protocols.capture.pain": "Pijn (0-10)",
  "protocols.capture.redness": "Roodheid (0-5)",
  "protocols.capture.itch": "Jeuk (0-5)",
  "protocols.capture.notes": "Wat je waarneemt",
  "protocols.capture.notes.placeholder": "Enkele woorden over wat je ziet of voelt…",
  "protocols.capture.upload": "Foto uploaden",
  "protocols.capture.take_selfie": "📷 Selfie nemen",
  "protocols.capture.upload_short": "🖼️ Foto kiezen",
  "protocols.capture.or": "of",
  "protocols.current_step.kicker": "Huidige fase",
  "protocols.current_step.cta": "Voeg de foto voor deze fase toe",
 "protocols.extension.kicker": "Opvolging verlengen",
 "protocols.extension.badge": "Bonus",
 "protocols.extension.cta": "Extensie activeren",
 "protocols.extension.preview": "Aan het eind van de kernfase krijg je een extensie aangeboden:",
 "protocols.toast.extended": "Extensie geactiveerd",
  "protocols.capture.checklist": "Opname-omstandigheden",
  "protocols.capture.cond.light": "Natuurlijk licht, geen flits",
  "protocols.capture.cond.bg": "Neutrale achtergrond",
  "protocols.capture.cond.distance": "Afstand ~30 cm, zelfde hoek",
  "protocols.capture.cond.framing": "De zone vult het kader",
  "photoguide.kicker": "Stapsgewijze gids",
  "photoguide.title": "Hoe maak je de foto en plaats je een maatreferentie",
  "photoguide.step1.title": "Licht",
  "photoguide.step1.body": "Ga voor een raam staan. Zet de flits uit — direct flitslicht maakt de textuur vlak en vervormt de kleuren.",
  "photoguide.step2.title": "Afstand",
  "photoguide.step2.body": "Houd de telefoon ongeveer een onderarmlengte van de zone. Gebruik dezelfde hoek als bij vorige opnames om te kunnen vergelijken.",
  "photoguide.step3.title": "Kadrering",
  "photoguide.step3.body": "De gevolgde zone moet het grootste deel van het kader vullen, goed gecentreerd en scherp. Vermijd schaduwen op de zone.",
  "photoguide.step4.title": "Maatreferentie",
  "photoguide.step4.body": "Leg een voorwerp van bekende grootte naast de zone: een muntstuk, lat of kalibratiesticker. Bedek de zone niet; houd beide in hetzelfde vlak.",
  "photoguide.step4.consistency.title": "Consistent kader",
  "photoguide.example.title": "Voorbeeld van een geslaagde foto",
  "photoguide.example.macro.caption": "Munt van 1 € plat op ~1 cm van de moedervlek, zacht daglicht, beide scherp in beeld.",
  "photoguide.example.fullbody.caption": "Volledig lichaam gecentreerd, hielen samen, lichte muur achter, telefoon op heuphoogte ~2 m afstand. Telkens dezelfde kleding.",
  "photoguide.example.video.caption": "Typische opstelling: telefoon verticaal op een klein statief, beeldzoeker op het silhouet.",
  "photoguide.example.face.caption": "Gezicht gecentreerd, haar naar achter, zacht daglicht, neutrale uitdrukking. Telkens hetzelfde kader.",
  "photoguide.example.scalp.caption": "Bovenaanzicht, middenscheiding scherp, licht van boven, zachte liniaal vlak voor dichtheidsmeting.",
  "photoguide.example.smile.caption": "Brede glimlach, tanden zichtbaar, witte kaart naast de wang als tintreferentie.",
  "photoguide.example.eyes.caption": "Kader van wenkbrauwen tot jukbeenderen, recht in de lens kijken, ochtendlicht, geen make-up.",
  "photoguide.example.back.caption": "Volledig achteraanzicht, hielen samen, armen langszij, lichte muur achter, telefoon op navelhoogte.",
  "photoguide.example.thighs.caption": "Achteraanzicht dijen, van heup tot boven knie, schuin zijlicht om reliëf te tonen.",
  "photoguide.example.belly.caption": "Volledig zijaanzicht borst tot heupen, armen lichtjes weg, zacht licht zonder flits. Telkens dezelfde outfit.",
  "photoguide.example.acne.caption": "Wang en kaaklijn van dichtbij, diffuus daglicht van voren, geen make-up of filter. Enkele ontstoken puistjes zichtbaar — textuur moet scherp blijven.",
  "photoguide.example.onco.caption": "Enkel gezicht en hals (geen volledig lichaam), telefoon op ~30 cm, zacht indirect licht, neutrale uitdrukking. Sjaal of muts mag — behoud telkens hetzelfde kader.",
  "photoguide.example.scars.caption": "Macro-kader van een lineair litteken met een muntstuk van 1 € plat op 1 cm. Zacht zijlicht onthult het reliëf.",
  "photoguide.example.meno_andro.caption": "Menopauze — gezicht op ~30 cm, haar naar achter, geen make-up, consistent daglicht (best telkens hetzelfde uur).",
  "photoguide.example.andro.caption": "Andropauze — gezicht op ~30 cm, neutrale uitdrukking, vensterlicht, geen filter. Gebruik telkens hetzelfde uur en dezelfde achtergrond.",
  "photoguide.example.tattoo.caption": "Geheelde tatoeage: volledig motief + 2 cm gezonde huid eromheen, muntstuk van 1 € ernaast. Indirect daglicht — vermijd LED's.",
  "photoguide.example.piercing.caption": "Recente piercing: sieraad gecentreerd en scherp, muntstuk van 1 € vlak ernaast. Indirect daglicht, raak de zone niet aan.",
  "photoguide.example.sobriety.caption": "Gezicht recht voor de camera op ~30 cm, neutrale uitdrukking, ochtendlicht. Maak de foto telkens op hetzelfde uur.",
  "photoguide.example.melasma.caption": "Melasma — symmetrische vlekken op jukbeenderen, voorhoofd en bovenlip. Alleen neutraal daglicht — vermijd halogeen.",
  "photoguide.example.rosacea.caption": "Rosacea / reactieve huid: diffuse roodheid centraal in het gezicht (wangen, neus) met fijne zichtbare capillairen. Enkel koel, stabiel daglicht — warm licht vervalst de tint. Geen make-up.",
  "photoguide.example.psoriasis.caption": "Eczeem/psoriasis-plek, duidelijk afgebakend. Kader plek + 3 cm gezonde huid eromheen, leg een 1 €-munt als grootte­referentie.",
  "photoguide.example.hairgraft_before.caption": "VOOR — vooraanzicht, neutraal licht van boven, haarlijn en donorzone zichtbaar. Droog haar, plat gekamd.",
  "photoguide.example.hairgraft_after.caption": "NA (m+3 tot m+12) — zelfde kader, hoek en licht als VOOR om dichtheid en haarlijn te vergelijken.",
  "photoguide.example.beard.caption": "Baard — vooraanzicht dan profielen, zacht zijlicht toont haardichtheid. Geen styling, geen trimmen vooraf.",
  "photoguide.example.brows.caption": "Wenkbrauwen & voorhoofd — kader van haarlijn tot jukbeenderen, geen make-up, rechte blik, ochtendlicht.",
  "photoguide.example.posture_front.caption": "Houding — vooraanzicht, blote voeten, hielen samen, armen langszij. Herhaal zijaanzicht EN achteraanzicht met identiek kader.",
  "photoguide.example.posture_back.caption": "Houding — achteraanzicht, zelfde stand. De 3de foto (profiel) toont uitlijning oor–schouder–heup–enkel.",
  "photoguide.example.pregnancy_side.caption": "Zwangerschap — volledig zijprofiel van borst tot heupen, armen lichtjes weg. Dit is het hoofdaanzicht voor silhouet.",
  "photoguide.example.pregnancy_front.caption": "Zwangerschap — vooraanzicht als aanvulling, telkens dezelfde nauwsluitende kleding. Optioneel: achteraanzicht voor lage rug.",
  "protocols.capture.submit": "Analyseer mijn foto",
  "protocols.capture.analyzing": "Bezig met analyseren…",
  "protocols.capture.disclaimer": "Niet-medische visuele observatie. Er wordt geen diagnose gesteld. Bij twijfel raadpleeg je behandelaar.",
  "protocols.capture.views.kicker": "Aanbevolen aanzichten",
  "protocols.capture.views.progress": "{n} van {total} aanzichten vastgelegd",
  "protocols.capture.views.next": "Volgend aanzicht: {label}",
  "protocols.capture.views.add": "Voeg aanzicht toe: {label}",
  "protocols.capture.views.skip": "Toch doorgaan",
  "protocols.capture.views.skip.notice": "Ik heb niet elk aanzicht — ik begrijp dat de analyse en aanbevelingen minder nauwkeurig zullen zijn.",
  "protocols.capture.views.missing.toast": "Ontbrekende aanzichten",
  "protocols.capture.views.missing.desc": "Voeg de resterende aanzichten toe voor een nauwkeurige analyse, of vink « Toch doorgaan » aan.",
  "protocols.observation.summary": "Visuele samenvatting",
  "protocols.observation.visible": "Zichtbare elementen",
  "protocols.observation.changes": "Evolutie",
  "protocols.observation.redflags": "Alarmsignalen",
  "protocols.observation.referral": "Raadpleeg je behandelaar binnen 24-48u",
  "protocols.observation.next": "Voorgestelde acties",
  "protocols.observation.quality": "Fotokwaliteit",
  "protocols.observation.done": "Observatie opgeslagen",
  "disclaimer.banner.label": "Belangrijke melding",
  "index.specialized.kicker": "Gespecialiseerde trajecten",
  "index.specialized.title": "Een protocol afgestemd op jouw levensmoment",
  "index.specialized.subtitle": "Begeleide trajecten om je voortgang week na week te volgen, in een helder en zorgzaam kader.",
  "index.specialized.card.kicker": "Protocol",
  "index.specialized.card.cta": "Ontdekken",
  "index.specialized.all": "Alle trajecten bekijken",
  "app.protocol.cta.kicker": "Ga verder",
  "app.protocol.cta.title": "Volg een protocol afgestemd op je doel: {0}",
  "app.protocol.cta.button": "Start dit traject",
  // Protocols — tier + lock
  "protocols.badge.pro": "Pro",
  "protocols.section.core.title": "Inbegrepen in je abonnement",
  "protocols.section.pro.title": "Pro Tracking",
  "protocols.section.pro.subtitle": "Geavanceerde dermato, haar en gespecialiseerde trajecten. Beschikbaar met de Pro Tracking-optie.",
  "protocols.locked.title": "Pro Tracking ontgrendelen",
  "protocols.locked.desc": "Toegang tot Rosacea, ABCDE moedervlek, Haar-dichtheid, Houding en 8 andere geleide protocollen.",
  "protocols.locked.cta": "Upgrade naar Pro Tracking",
  "protocols.locked.trial": "7 dagen gratis proberen — altijd opzegbaar.",
  "protocols.locked.coming_soon": "Pro Tracking komt binnenkort — je wordt verwittigd bij de lancering.",
  "protocols.locked.dismiss": "Later",
  "protocols.referral.derma.title": "Bezoek aan dermatoloog aanbevolen",
  "protocols.referral.derma.desc": "Dit traject is enkel een visueel opvolgingsinstrument. Laat deze zone nu door een dermatoloog onderzoeken en gebruik daarna de app om de evolutie te documenteren.",
  "protocols.referral.physician.title": "Medisch advies aanbevolen",
  "protocols.referral.physician.desc": "Hier wordt geen diagnose gesteld. Laat je situatie eerst door een arts beoordelen.",
  "protocols.referral.midwife.title": "Advies vroedvrouw / arts aanbevolen",
  "protocols.referral.midwife.desc": "Voor elke twijfel rond zwangerschap of post-partum: contacteer je vroedvrouw of arts.",
  // Capture Coach
  "coach.badge.focus": "Scherpte",
  "coach.badge.lighting": "Licht",
  "coach.badge.framing": "Kadrering",
  "coach.ghost.show": "Vorige foto tonen",
  "coach.ghost.hide": "Vorige foto verbergen",
  "coach.retake": "Andere foto kiezen",
  "coach.pro.title": "Pro-coach — pre-check & geleide burst",
  "coach.pre.button": "AI pre-check",
  "coach.pre.checking": "Analyse loopt…",
  "coach.pre.score": "Foto-score",
  "coach.pre.ready": "Klaar om te fotograferen",
  "coach.pre.notready": "Te verbeteren",
  "coach.burst.button": "Geleide burst (3–6 foto's)",
  "coach.burst.picking": "Beste frame kiezen…",
  "coach.burst.picked": "Beste foto gekozen",
  "coach.burst.result": "Van {0} foto's is #{1} het scherpst",
  "coach.burst.tap_to_pick": "Tik op een miniatuur om een andere foto te kiezen voor analyse.",
  "coach.pre.quota.remaining": "{0}/{1} AI pre-checks over vandaag · reset om {2}",
  "coach.pre.quota.exhausted": "Daglimiet bereikt — nieuwe pre-checks beschikbaar om {0}.",
  "coach.pre.quota.tooltip": "Beperkt tot {0} AI pre-checks per dag om de servicekwaliteit en AI-kosten in toom te houden.",
  "coach.pre.err.rate_limited": "Te veel verzoeken — probeer het over enkele seconden opnieuw.",
  "coach.pre.err.credits": "AI-credits tijdelijk uitgeput. Probeer later opnieuw of neem contact op met support.",
  "protocols.locked.limits.title": "Goed om te weten vóór je abonneert",
  "protocols.locked.limits.preflight": "AI-fotopre-check is beperkt tot 30 pogingen per dag per account. Dit beschermt de servicekwaliteit en houdt de AI-kosten beheersbaar — ruim voldoende voor normaal dagelijks gebruik. Geleide burst en protocoltracking zijn niet beperkt.",
  "protocols.locked.detail.title": "Pro-protocol — voorbeeld",
  "protocols.locked.detail.desc": "Je kunt vrij door de inhoud, stappen en fotogids van dit protocol bladeren. Om het effectief te starten en je sessies te bewaren, activeer Pro Tracking.",
  "protocols.locked.detail.preview": "Voorbeeldmodus: foto's en sessies worden pas bewaard na activering van het abonnement.",
  "checkout.tier.premium": "Premium",
  "checkout.tier.pro": "Pro (inclusief Premium)",
  "checkout.tier.pro.trial_note": "7 dagen gratis proberen, altijd opzegbaar.",
  "notes.title": "Jouw notities (optioneel)",
  "notes.help": "Vermeld wat de foto kan beïnvloeden (recente kapper, zonnebrand, nieuwe crème, make-up, slechte nachtrust…). De AI gebruikt dit om variaties te begrijpen.",
  "notes.placeholder": "Bijv. nieuwe retinolcrème sinds 5 dagen, zonnig weekend, slecht geslapen…",
  "notes.action.haircut": "Knipbeurt",
  "notes.action.shave": "Scheren / baard bijgewerkt",
  "notes.action.new_cream": "Nieuwe crème / serum",
  "notes.action.sun": "Blootstelling aan zon",
  "notes.action.treatment": "Esthetische behandeling",
  "notes.action.makeup": "Make-up / foundation",
  "notes.action.filter_off": "Geen filter",
  "notes.action.poor_sleep": "Slecht geslapen",
  "notes.action.workout": "Recente intensieve work-out",
  "notes.action.alcohol": "Gisteren alcohol",
  "notes.section_title": "Door jou opgegeven context",
  "notes.add": "+ Notitie of actie toevoegen",
  "notes.edit": "✎ Notities bewerken",
  "notes.modal.title": "Jouw notities bij deze analyse",
  "notes.cancel": "Annuleren",
  "notes.save": "Opslaan",
  "notes.saved": "Notities opgeslagen",
  "billing.redeem.kicker": "Toegangscode",
  "billing.redeem.title": "Ik heb een gratis code",
  "billing.redeem.help": "Als je een code hebt gekregen (Premium of Pro), voer hem hier in om je toegang te activeren — zonder Stripe.",
  "billing.redeem.cta": "Activeren",
  "billing.redeem.success_premium": "Code geactiveerd: Premium ontgrendeld ✨",
  "billing.redeem.success_pro": "Code geactiveerd: Pro ontgrendeld 🚀",
};

export const DICT: Record<Locale, Dict> = { fr, en, nl };

export function translate(locale: Locale, key: string, ...args: (string | number)[]): string {
  const dict = DICT[locale] ?? DICT.fr;
  let str = dict[key] ?? DICT.fr[key] ?? key;
  for (let i = 0; i < args.length; i++) {
    str = str.replace(`{${i}}`, String(args[i]));
  }
  return str;
}
